/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import { type Analysis, AnalysisFromJSON, AnalysisToJSON } from "../models/Analysis";
import {
  type AnalysisProcess,
  AnalysisProcessFromJSON,
  AnalysisProcessToJSON,
} from "../models/AnalysisProcess";
import {
  type ApiBulkuploadsList200Response,
  ApiBulkuploadsList200ResponseFromJSON,
  ApiBulkuploadsList200ResponseToJSON,
} from "../models/ApiBulkuploadsList200Response";
import {
  type ApiFrdFrdsList200Response,
  ApiFrdFrdsList200ResponseFromJSON,
  ApiFrdFrdsList200ResponseToJSON,
} from "../models/ApiFrdFrdsList200Response";
import {
  type ApiFrdGeoelectricmeasurementsList200Response,
  ApiFrdGeoelectricmeasurementsList200ResponseFromJSON,
  ApiFrdGeoelectricmeasurementsList200ResponseToJSON,
} from "../models/ApiFrdGeoelectricmeasurementsList200Response";
import {
  type ApiFrdGeoelectricmeasuresList200Response,
  ApiFrdGeoelectricmeasuresList200ResponseFromJSON,
  ApiFrdGeoelectricmeasuresList200ResponseToJSON,
} from "../models/ApiFrdGeoelectricmeasuresList200Response";
import {
  type ApiFrdIdsList200Response,
  ApiFrdIdsList200ResponseFromJSON,
  ApiFrdIdsList200ResponseToJSON,
} from "../models/ApiFrdIdsList200Response";
import {
  type ApiFrdMeasurementconfigurationsList200Response,
  ApiFrdMeasurementconfigurationsList200ResponseFromJSON,
  ApiFrdMeasurementconfigurationsList200ResponseToJSON,
} from "../models/ApiFrdMeasurementconfigurationsList200Response";
import {
  type ApiGarAnalysesList200Response,
  ApiGarAnalysesList200ResponseFromJSON,
  ApiGarAnalysesList200ResponseToJSON,
} from "../models/ApiGarAnalysesList200Response";
import {
  type ApiGarAnalysisprocessesList200Response,
  ApiGarAnalysisprocessesList200ResponseFromJSON,
  ApiGarAnalysisprocessesList200ResponseToJSON,
} from "../models/ApiGarAnalysisprocessesList200Response";
import {
  type ApiGarFieldmeasurementsList200Response,
  ApiGarFieldmeasurementsList200ResponseFromJSON,
  ApiGarFieldmeasurementsList200ResponseToJSON,
} from "../models/ApiGarFieldmeasurementsList200Response";
import {
  type ApiGarGarsList200Response,
  ApiGarGarsList200ResponseFromJSON,
  ApiGarGarsList200ResponseToJSON,
} from "../models/ApiGarGarsList200Response";
import {
  type ApiGarIdsList200Response,
  ApiGarIdsList200ResponseFromJSON,
  ApiGarIdsList200ResponseToJSON,
} from "../models/ApiGarIdsList200Response";
import {
  type ApiGarLaboratoryresearchesList200Response,
  ApiGarLaboratoryresearchesList200ResponseFromJSON,
  ApiGarLaboratoryresearchesList200ResponseToJSON,
} from "../models/ApiGarLaboratoryresearchesList200Response";
import {
  type ApiGldGldsList200Response,
  ApiGldGldsList200ResponseFromJSON,
  ApiGldGldsList200ResponseToJSON,
} from "../models/ApiGldGldsList200Response";
import {
  type ApiGldIdsList200Response,
  ApiGldIdsList200ResponseFromJSON,
  ApiGldIdsList200ResponseToJSON,
} from "../models/ApiGldIdsList200Response";
import {
  type ApiGldObservationsList200Response,
  ApiGldObservationsList200ResponseFromJSON,
  ApiGldObservationsList200ResponseToJSON,
} from "../models/ApiGldObservationsList200Response";
import {
  type ApiGldOverviewList200Response,
  ApiGldOverviewList200ResponseFromJSON,
  ApiGldOverviewList200ResponseToJSON,
} from "../models/ApiGldOverviewList200Response";
import {
  type ApiGmnEventsList200Response,
  ApiGmnEventsList200ResponseFromJSON,
  ApiGmnEventsList200ResponseToJSON,
} from "../models/ApiGmnEventsList200Response";
import {
  type ApiGmnGmnsList200Response,
  ApiGmnGmnsList200ResponseFromJSON,
  ApiGmnGmnsList200ResponseToJSON,
} from "../models/ApiGmnGmnsList200Response";
import {
  type ApiGmnIdsList200Response,
  ApiGmnIdsList200ResponseFromJSON,
  ApiGmnIdsList200ResponseToJSON,
} from "../models/ApiGmnIdsList200Response";
import {
  type ApiGmnMeasuringpointsList200Response,
  ApiGmnMeasuringpointsList200ResponseFromJSON,
  ApiGmnMeasuringpointsList200ResponseToJSON,
} from "../models/ApiGmnMeasuringpointsList200Response";
import {
  type ApiGmnOverviewList200Response,
  ApiGmnOverviewList200ResponseFromJSON,
  ApiGmnOverviewList200ResponseToJSON,
} from "../models/ApiGmnOverviewList200Response";
import {
  type ApiGmwEventsList200Response,
  ApiGmwEventsList200ResponseFromJSON,
  ApiGmwEventsList200ResponseToJSON,
} from "../models/ApiGmwEventsList200Response";
import {
  type ApiGmwGeojsonList200Response,
  ApiGmwGeojsonList200ResponseFromJSON,
  ApiGmwGeojsonList200ResponseToJSON,
} from "../models/ApiGmwGeojsonList200Response";
import {
  type ApiGmwGmwsList200Response,
  ApiGmwGmwsList200ResponseFromJSON,
  ApiGmwGmwsList200ResponseToJSON,
} from "../models/ApiGmwGmwsList200Response";
import {
  type ApiGmwIdsList200Response,
  ApiGmwIdsList200ResponseFromJSON,
  ApiGmwIdsList200ResponseToJSON,
} from "../models/ApiGmwIdsList200Response";
import {
  type ApiGmwMonitoringtubesList200Response,
  ApiGmwMonitoringtubesList200ResponseFromJSON,
  ApiGmwMonitoringtubesList200ResponseToJSON,
} from "../models/ApiGmwMonitoringtubesList200Response";
import {
  type ApiGmwOverviewList200Response,
  ApiGmwOverviewList200ResponseFromJSON,
  ApiGmwOverviewList200ResponseToJSON,
} from "../models/ApiGmwOverviewList200Response";
import {
  type ApiGpdGpdsList200Response,
  ApiGpdGpdsList200ResponseFromJSON,
  ApiGpdGpdsList200ResponseToJSON,
} from "../models/ApiGpdGpdsList200Response";
import {
  type ApiGpdIdsList200Response,
  ApiGpdIdsList200ResponseFromJSON,
  ApiGpdIdsList200ResponseToJSON,
} from "../models/ApiGpdIdsList200Response";
import {
  type ApiGpdReportsList200Response,
  ApiGpdReportsList200ResponseFromJSON,
  ApiGpdReportsList200ResponseToJSON,
} from "../models/ApiGpdReportsList200Response";
import {
  type ApiGpdVolumeSeriesList200Response,
  ApiGpdVolumeSeriesList200ResponseFromJSON,
  ApiGpdVolumeSeriesList200ResponseToJSON,
} from "../models/ApiGpdVolumeSeriesList200Response";
import {
  type ApiGufEnergycharacteristicsList200Response,
  ApiGufEnergycharacteristicsList200ResponseFromJSON,
  ApiGufEnergycharacteristicsList200ResponseToJSON,
} from "../models/ApiGufEnergycharacteristicsList200Response";
import {
  type ApiGufEventsList200Response,
  ApiGufEventsList200ResponseFromJSON,
  ApiGufEventsList200ResponseToJSON,
} from "../models/ApiGufEventsList200Response";
import {
  type ApiGufGufsList200Response,
  ApiGufGufsList200ResponseFromJSON,
  ApiGufGufsList200ResponseToJSON,
} from "../models/ApiGufGufsList200Response";
import {
  type ApiGufIdsList200Response,
  ApiGufIdsList200ResponseFromJSON,
  ApiGufIdsList200ResponseToJSON,
} from "../models/ApiGufIdsList200Response";
import {
  type ApiGufInstallationsList200Response,
  ApiGufInstallationsList200ResponseFromJSON,
  ApiGufInstallationsList200ResponseToJSON,
} from "../models/ApiGufInstallationsList200Response";
import {
  type ApiGufLoopsList200Response,
  ApiGufLoopsList200ResponseFromJSON,
  ApiGufLoopsList200ResponseToJSON,
} from "../models/ApiGufLoopsList200Response";
import {
  type ApiGufSurfaceinfiltrationsList200Response,
  ApiGufSurfaceinfiltrationsList200ResponseFromJSON,
  ApiGufSurfaceinfiltrationsList200ResponseToJSON,
} from "../models/ApiGufSurfaceinfiltrationsList200Response";
import {
  type ApiGufWellsList200Response,
  ApiGufWellsList200ResponseFromJSON,
  ApiGufWellsList200ResponseToJSON,
} from "../models/ApiGufWellsList200Response";
import {
  type ApiImporttasksList200Response,
  ApiImporttasksList200ResponseFromJSON,
  ApiImporttasksList200ResponseToJSON,
} from "../models/ApiImporttasksList200Response";
import {
  type ApiObjectimporttasksList200Response,
  ApiObjectimporttasksList200ResponseFromJSON,
  ApiObjectimporttasksList200ResponseToJSON,
} from "../models/ApiObjectimporttasksList200Response";
import {
  type ApiOrganisationsList200Response,
  ApiOrganisationsList200ResponseFromJSON,
  ApiOrganisationsList200ResponseToJSON,
} from "../models/ApiOrganisationsList200Response";
import {
  type ApiUploadtasksList200Response,
  ApiUploadtasksList200ResponseFromJSON,
  ApiUploadtasksList200ResponseToJSON,
} from "../models/ApiUploadtasksList200Response";
import {
  type ApiUploadtasksOverviewList200Response,
  ApiUploadtasksOverviewList200ResponseFromJSON,
  ApiUploadtasksOverviewList200ResponseToJSON,
} from "../models/ApiUploadtasksOverviewList200Response";
import {
  type ApiUsersList200Response,
  ApiUsersList200ResponseFromJSON,
  ApiUsersList200ResponseToJSON,
} from "../models/ApiUsersList200Response";
import { type BulkUpload, BulkUploadFromJSON, BulkUploadToJSON } from "../models/BulkUpload";
import {
  type DesignInstallation,
  DesignInstallationFromJSON,
  DesignInstallationToJSON,
} from "../models/DesignInstallation";
import { type DesignLoop, DesignLoopFromJSON, DesignLoopToJSON } from "../models/DesignLoop";
import {
  type DesignSurfaceInfiltration,
  DesignSurfaceInfiltrationFromJSON,
  DesignSurfaceInfiltrationToJSON,
} from "../models/DesignSurfaceInfiltration";
import { type DesignWell, DesignWellFromJSON, DesignWellToJSON } from "../models/DesignWell";
import {
  type EnergyCharacteristics,
  EnergyCharacteristicsFromJSON,
  EnergyCharacteristicsToJSON,
} from "../models/EnergyCharacteristics";
import { type Event, EventFromJSON, EventToJSON } from "../models/Event";
import { type FRD, FRDFromJSON, FRDToJSON } from "../models/FRD";
import {
  type FieldMeasurement,
  FieldMeasurementFromJSON,
  FieldMeasurementToJSON,
} from "../models/FieldMeasurement";
import { type GAR, GARFromJSON, GARToJSON } from "../models/GAR";
import { type GLD, GLDFromJSON, GLDToJSON } from "../models/GLD";
import { type GMN, GMNFromJSON, GMNToJSON } from "../models/GMN";
import { type GMW, GMWFromJSON, GMWToJSON } from "../models/GMW";
import { type GPD, GPDFromJSON, GPDToJSON } from "../models/GPD";
import { type GUFDetail, GUFDetailFromJSON, GUFDetailToJSON } from "../models/GUFDetail";
import { type GUFEvent, GUFEventFromJSON, GUFEventToJSON } from "../models/GUFEvent";
import {
  type GeoElectricMeasure,
  GeoElectricMeasureFromJSON,
  GeoElectricMeasureToJSON,
} from "../models/GeoElectricMeasure";
import {
  type GeoElectricMeasurement,
  GeoElectricMeasurementFromJSON,
  GeoElectricMeasurementToJSON,
} from "../models/GeoElectricMeasurement";
import { type ImportTask, ImportTaskFromJSON, ImportTaskToJSON } from "../models/ImportTask";
import {
  type IntermediateEvent,
  IntermediateEventFromJSON,
  IntermediateEventToJSON,
} from "../models/IntermediateEvent";
import {
  type LaboratoryResearch,
  LaboratoryResearchFromJSON,
  LaboratoryResearchToJSON,
} from "../models/LaboratoryResearch";
import {
  type MeasurementConfiguration,
  MeasurementConfigurationFromJSON,
  MeasurementConfigurationToJSON,
} from "../models/MeasurementConfiguration";
import {
  type Measuringpoint,
  MeasuringpointFromJSON,
  MeasuringpointToJSON,
} from "../models/Measuringpoint";
import {
  type MonitoringTube,
  MonitoringTubeFromJSON,
  MonitoringTubeToJSON,
} from "../models/MonitoringTube";
import {
  type ObjectImportTask,
  ObjectImportTaskFromJSON,
  ObjectImportTaskToJSON,
} from "../models/ObjectImportTask";
import { type Observation, ObservationFromJSON, ObservationToJSON } from "../models/Observation";
import {
  type Organisation,
  type FullOrganisation,
  OrganisationFromJSON,
  OrganisationToJSON,
  FullOrganisationFromJSON,
  FullOrganisationToJSON,
} from "../models/Organisation";
import { type Report, ReportFromJSON, ReportToJSON } from "../models/Report";
import { type UploadTask, UploadTaskFromJSON, UploadTaskToJSON } from "../models/UploadTask";
import { type User, UserFromJSON, UserToJSON } from "../models/User";
import {
  type UserLoggedIn,
  UserLoggedInFromJSON,
  UserLoggedInToJSON,
} from "../models/UserLoggedIn";
import {
  type VolumeSeries,
  VolumeSeriesFromJSON,
  VolumeSeriesToJSON,
} from "../models/VolumeSeries";

export interface ApiBulkuploadsCreateRequest {
  projectNumber: string;
  fieldworkFile?: Blob;
  labFile?: Blob;
  measurementTvpFile?: Blob;
  bulkUploadType?: ApiBulkuploadsCreateBulkUploadTypeEnum;
  requestType?: ApiBulkuploadsCreateRequestTypeEnum;
  metadata?: string;
  sourcedocumentData?: string;
  status?: ApiBulkuploadsCreateStatusEnum;
  log?: string;
  progress?: number | null;
  dataOwner?: string | null;
}

export interface ApiBulkuploadsDeleteRequest {
  uuid: string;
}

export interface ApiBulkuploadsListRequest {
  page?: number;
}

export interface ApiBulkuploadsPartialUpdateRequest {
  uuid: string;
  projectNumber: string;
  fieldworkFile?: Blob;
  labFile?: Blob;
  measurementTvpFile?: Blob;
  bulkUploadType?: ApiBulkuploadsPartialUpdateBulkUploadTypeEnum;
  requestType?: ApiBulkuploadsPartialUpdateRequestTypeEnum;
  metadata?: string;
  sourcedocumentData?: string;
  status?: ApiBulkuploadsPartialUpdateStatusEnum;
  log?: string;
  progress?: number | null;
  dataOwner?: string | null;
}

export interface ApiBulkuploadsReadRequest {
  uuid: string;
}

export interface ApiBulkuploadsUpdateRequest {
  uuid: string;
  projectNumber: string;
  fieldworkFile?: Blob;
  labFile?: Blob;
  measurementTvpFile?: Blob;
  bulkUploadType?: ApiBulkuploadsUpdateBulkUploadTypeEnum;
  requestType?: ApiBulkuploadsUpdateRequestTypeEnum;
  metadata?: string;
  sourcedocumentData?: string;
  status?: ApiBulkuploadsUpdateStatusEnum;
  log?: string;
  progress?: number | null;
  dataOwner?: string | null;
}

export interface ApiFrdFrdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  linkedGmns?: string;
  monitoringTube?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  determinationType?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  researchFirstDate?: string;
  researchLastDate?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  gmwBroIdIcontains?: string;
  gmw?: string;
  page?: number;
}

export interface ApiFrdFrdsReadRequest {
  uuid: string;
}

export interface ApiFrdGeoelectricmeasurementsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  frd?: string;
  measurementDate?: string;
  determinationProcedure?: string;
  evaluationProcedure?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiFrdGeoelectricmeasurementsReadRequest {
  uuid: string;
}

export interface ApiFrdGeoelectricmeasuresListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  geoElectricMeasurement?: string;
  resistance?: string;
  relatedMeasurementConfiguration?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiFrdGeoelectricmeasuresReadRequest {
  uuid: string;
}

export interface ApiFrdIdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  linkedGmns?: string;
  monitoringTube?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  determinationType?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  researchFirstDate?: string;
  researchLastDate?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  gmwBroIdIcontains?: string;
  gmw?: string;
  page?: number;
}

export interface ApiFrdMeasurementconfigurationsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  frd?: string;
  measurementConfigurationId?: string;
  measurementPair?: string;
  currentPair?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiFrdMeasurementconfigurationsReadRequest {
  uuid: string;
}

export interface ApiGarAnalysesListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  analysisProcess?: string;
  parameter?: string;
  limitSymbol?: string;
  unit?: string;
  value?: string;
  reportingLimit?: string;
  statusQualityControl?: ApiGarAnalysesListStatusQualityControlEnum;
  dataOwner?: string;
  page?: number;
}

export interface ApiGarAnalysesReadRequest {
  uuid: string;
}

export interface ApiGarAnalysisprocessesListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  laboratoryResearch?: string;
  analysesDate?: string;
  analyticalTechnique?: string;
  validationMethod?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiGarAnalysisprocessesReadRequest {
  uuid: string;
}

export interface ApiGarFieldmeasurementsListRequest {
  uuid?: string;
  gar?: string;
  created?: string;
  updated?: string;
  parameter?: string;
  unit?: string;
  fieldMeasurementValue?: string;
  qualityControlStatus?: ApiGarFieldmeasurementsListQualityControlStatusEnum;
  dataOwner?: string;
  page?: number;
}

export interface ApiGarFieldmeasurementsReadRequest {
  uuid: string;
}

export interface ApiGarGarsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  monitoringTube?: string;
  qualityControlMethod?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  samplingDatetime?: string;
  samplingStandard?: string;
  primaryColour?: string;
  secondaryColour?: string;
  colourStrength?: string;
  pumpType?: string;
  abnormalityInCooling?: string;
  abnormalityInDevice?: string;
  pollutedByEngine?: string;
  filterAerated?: string;
  groundwaterLevelDroppedTooMuch?: string;
  abnormalFilter?: string;
  sampleAerated?: string;
  hoseReused?: string;
  temperatureDifficultToMeasure?: string;
  labAnalysisDate?: string;
  broIdIcontains?: string;
  gmwBroIdIcontains?: string;
  page?: number;
}

export interface ApiGarGarsReadRequest {
  uuid: string;
}

export interface ApiGarIdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  monitoringTube?: string;
  qualityControlMethod?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  samplingDatetime?: string;
  samplingStandard?: string;
  primaryColour?: string;
  secondaryColour?: string;
  colourStrength?: string;
  pumpType?: string;
  abnormalityInCooling?: string;
  abnormalityInDevice?: string;
  pollutedByEngine?: string;
  filterAerated?: string;
  groundwaterLevelDroppedTooMuch?: string;
  abnormalFilter?: string;
  sampleAerated?: string;
  hoseReused?: string;
  temperatureDifficultToMeasure?: string;
  labAnalysisDate?: string;
  broIdIcontains?: string;
  gmwBroIdIcontains?: string;
  page?: number;
}

export interface ApiGarLaboratoryresearchesListRequest {
  uuid?: string;
  gar?: string;
  created?: string;
  updated?: string;
  laboratoryKvkNumber?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiGarLaboratoryresearchesReadRequest {
  uuid: string;
}

export interface ApiGldGldsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  linkedGmns?: string;
  monitoringTube?: string;
  qualityRegime?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  researchFirstDate?: string;
  researchLastDate?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  researchFirstDateGt?: string;
  researchFirstDateGte?: string;
  researchFirstDateLt?: string;
  researchFirstDateLte?: string;
  page?: number;
}

export interface ApiGldGldsReadRequest {
  uuid: string;
}

export interface ApiGldIdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  linkedGmns?: string;
  monitoringTube?: string;
  qualityRegime?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  researchFirstDate?: string;
  researchLastDate?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  researchFirstDateGt?: string;
  researchFirstDateGte?: string;
  researchFirstDateLt?: string;
  researchFirstDateLte?: string;
  page?: number;
}

export interface ApiGldObservationsListRequest {
  uuid?: string;
  gld?: string;
  observationId?: string;
  beginPosition?: string;
  endPosition?: string;
  resultTime?: string;
  validationStatus?: string;
  investigatorKvk?: string;
  observationType?: string;
  processReference?: string;
  airPressureCompensationType?: string;
  evaluationProcedure?: string;
  measurementInstrumentType?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  beginPositionGt?: string;
  beginPositionGte?: string;
  beginPositionLt?: string;
  beginPositionLte?: string;
  page?: number;
}

export interface ApiGldObservationsReadRequest {
  uuid: string;
}

export interface ApiGldOverviewListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  linkedGmns?: string;
  monitoringTube?: string;
  qualityRegime?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  researchFirstDate?: string;
  researchLastDate?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  researchFirstDateGt?: string;
  researchFirstDateGte?: string;
  researchFirstDateLt?: string;
  researchFirstDateLte?: string;
  page?: number;
}

export interface ApiGmnEventsListRequest {
  uuid?: string;
  gmn?: string;
  eventType?: ApiGmnEventsListEventTypeEnum;
  eventDate?: string;
  measuringpointCode?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  dataOwner?: string;
  created?: string;
  updated?: string;
  measuringpointStartDateGt?: string;
  measuringpointStartDateGte?: string;
  measuringpointStartDateLt?: string;
  measuringpointStartDateLte?: string;
  page?: number;
}

export interface ApiGmnEventsReadRequest {
  uuid: string;
}

export interface ApiGmnGmnsListRequest {
  uuid?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  name?: string;
  deliveryContext?: string;
  monitoringPurpose?: string;
  groundwaterAspect?: string;
  startDateMonitoring?: string;
  endDateMonitoring?: string;
  objectRegistrationTime?: string;
  registrationStatus?: string;
  color?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  startDateMonitoringGt?: string;
  startDateMonitoringGte?: string;
  startDateMonitoringLt?: string;
  startDateMonitoringLte?: string;
  page?: number;
}

export interface ApiGmnGmnsReadRequest {
  uuid: string;
}

export interface ApiGmnIdsListRequest {
  uuid?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  name?: string;
  deliveryContext?: string;
  monitoringPurpose?: string;
  groundwaterAspect?: string;
  startDateMonitoring?: string;
  endDateMonitoring?: string;
  objectRegistrationTime?: string;
  registrationStatus?: string;
  color?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  startDateMonitoringGt?: string;
  startDateMonitoringGte?: string;
  startDateMonitoringLt?: string;
  startDateMonitoringLte?: string;
  page?: number;
}

export interface ApiGmnMeasuringpointsListRequest {
  uuid?: string;
  gmn?: string;
  monitoringTube?: string;
  eventType?: ApiGmnMeasuringpointsListEventTypeEnum;
  measuringpointCode?: string;
  measuringpointStartDate?: string;
  measuringpointEndDate?: string;
  gmwBroId?: string;
  tubeNumber?: string;
  tubeStartDate?: string;
  tubeEndDate?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  measuringpointStartDateGt?: string;
  measuringpointStartDateGte?: string;
  measuringpointStartDateLt?: string;
  measuringpointStartDateLte?: string;
  page?: number;
}

export interface ApiGmnMeasuringpointsReadRequest {
  uuid: string;
}

export interface ApiGmnOverviewListRequest {
  uuid?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  name?: string;
  deliveryContext?: string;
  monitoringPurpose?: string;
  groundwaterAspect?: string;
  startDateMonitoring?: string;
  endDateMonitoring?: string;
  objectRegistrationTime?: string;
  registrationStatus?: string;
  color?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  startDateMonitoringGt?: string;
  startDateMonitoringGte?: string;
  startDateMonitoringLt?: string;
  startDateMonitoringLte?: string;
  page?: number;
}

export interface ApiGmwEventsListRequest {
  uuid?: string;
  gmw?: string;
  eventName?: string;
  eventDate?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  gmwBroId?: string;
  eventDateGt?: string;
  eventDateGte?: string;
  eventDateLt?: string;
  eventDateLte?: string;
  page?: number;
}

export interface ApiGmwEventsReadRequest {
  uuid: string;
}

export interface ApiGmwGmwsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  wellConstructionDate?: string;
  deliveryContext?: string;
  constructionStandard?: string;
  initialFunction?: string;
  removed?: string;
  groundLevelStable?: string;
  wellStability?: string;
  nitgCode?: string;
  wellCode?: string;
  owner?: string;
  wellHeadProtector?: string;
  deliveredLocation?: string;
  horizontalPositioningMethod?: string;
  localVerticalReferencePoint?: string;
  offset?: string;
  verticalDatum?: string;
  groundLevelPosition?: string;
  groundLevelPositioningMethod?: string;
  standardizedLocation?: string;
  objectRegistrationTime?: string;
  registrationStatus?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  internalIdIcontains?: string;
  wellCodeIcontains?: string;
  nitgCodeIcontains?: string;
  wellConstructionDateIcontains?: string;
  linkedGmn?: string;
  page?: number;
}

export interface ApiGmwGmwsReadRequest {
  uuid: string;
}

export interface ApiGmwIdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  wellConstructionDate?: string;
  deliveryContext?: string;
  constructionStandard?: string;
  initialFunction?: string;
  removed?: string;
  groundLevelStable?: string;
  wellStability?: string;
  nitgCode?: string;
  wellCode?: string;
  owner?: string;
  wellHeadProtector?: string;
  deliveredLocation?: string;
  horizontalPositioningMethod?: string;
  localVerticalReferencePoint?: string;
  offset?: string;
  verticalDatum?: string;
  groundLevelPosition?: string;
  groundLevelPositioningMethod?: string;
  standardizedLocation?: string;
  objectRegistrationTime?: string;
  registrationStatus?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  internalIdIcontains?: string;
  wellCodeIcontains?: string;
  nitgCodeIcontains?: string;
  wellConstructionDateIcontains?: string;
  linkedGmn?: string;
  page?: number;
}

export interface ApiGmwMonitoringtubesListRequest {
  uuid?: string;
  gmw?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  tubeNumber?: string;
  tubeType?: string;
  artesianWellCapPresent?: string;
  sedimentSumpPresent?: string;
  sedimentSumpLength?: string;
  numberOfGeoOhmCables?: string;
  tubeTopDiameter?: string;
  variableDiameter?: string;
  tubeStatus?: string;
  tubeTopPosition?: string;
  tubeTopPositioningMethod?: string;
  tubePartInserted?: string;
  tubeInUse?: string;
  tubePackingMaterial?: string;
  tubeMaterial?: string;
  glue?: string;
  screenLength?: string;
  screenProtection?: string;
  sockMaterial?: string;
  screenTopPosition?: string;
  screenBottomPosition?: string;
  plainTubePartLength?: string;
  gmnBroId?: string;
  gmwBroId?: string;
  page?: number;
}

export interface ApiGmwMonitoringtubesReadRequest {
  uuid: string;
}

export interface ApiGmwOverviewListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  wellConstructionDate?: string;
  deliveryContext?: string;
  constructionStandard?: string;
  initialFunction?: string;
  removed?: string;
  groundLevelStable?: string;
  wellStability?: string;
  nitgCode?: string;
  wellCode?: string;
  owner?: string;
  wellHeadProtector?: string;
  deliveredLocation?: string;
  horizontalPositioningMethod?: string;
  localVerticalReferencePoint?: string;
  offset?: string;
  verticalDatum?: string;
  groundLevelPosition?: string;
  groundLevelPositioningMethod?: string;
  standardizedLocation?: string;
  objectRegistrationTime?: string;
  registrationStatus?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  internalIdIcontains?: string;
  wellCodeIcontains?: string;
  nitgCodeIcontains?: string;
  wellConstructionDateIcontains?: string;
  linkedGmn?: string;
  page?: number;
}

export interface ApiGpdGpdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  startTime?: string;
  endTime?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  page?: number;
}

export interface ApiGpdGpdsReadRequest {
  uuid: string;
}

export interface ApiGpdIdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: string;
  startTime?: string;
  endTime?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  page?: number;
}

export interface ApiGpdReportsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  gpd?: string;
  reportId?: string;
  method?: ApiGpdReportsListMethodEnum;
  beginDate?: string;
  endDate?: string;
  groundwaterUsageFacilityBroId?: string;
  dataOwner?: string;
  reportIdIcontains?: string;
  page?: number;
}

export interface ApiGpdReportsReadRequest {
  uuid: string;
}

export interface ApiGpdVolumeSeriesListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  report?: string;
  beginDate?: string;
  endDate?: string;
  waterInOut?: ApiGpdVolumeSeriesListWaterInOutEnum;
  temperature?: ApiGpdVolumeSeriesListTemperatureEnum;
  volume?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiGpdVolumeSeriesReadRequest {
  uuid: string;
}

export interface ApiGufEnergycharacteristicsListRequest {
  uuid?: string;
  installation?: string;
  created?: string;
  updated?: string;
  energyCold?: string;
  energyWarm?: string;
  maximumInfiltrationTemperatureWarm?: string;
  averageInfiltrationTemperatureCold?: string;
  averageInfiltrationTemperatureWarm?: string;
  powerCold?: string;
  powerWarm?: string;
  power?: string;
  averageWarmWater?: string;
  averageColdWater?: string;
  maximumYearQuantityWarm?: string;
  maximumYearQuantityCold?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiGufEnergycharacteristicsReadRequest {
  uuid: string;
}

export interface ApiGufEventsListRequest {
  uuid?: string;
  guf?: string;
  eventName?: string;
  eventDate?: string;
  metadata?: string;
  sourcedocumentData?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  page?: number;
}

export interface ApiGufEventsReadRequest {
  uuid: string;
}

export interface ApiGufGufsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: ApiGufGufsListQualityRegimeEnum;
  deliveryContext?: ApiGufGufsListDeliveryContextEnum;
  startTime?: string;
  endTime?: string;
  identificationLicence?: string;
  legalType?: ApiGufGufsListLegalTypeEnum;
  primaryUsageType?: ApiGufGufsListPrimaryUsageTypeEnum;
  secondaryUsageTypes?: string;
  humanConsumption?: ApiGufGufsListHumanConsumptionEnum;
  licensedQuantities?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  page?: number;
}

export interface ApiGufGufsReadRequest {
  uuid: string;
}

export interface ApiGufIdsListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  internalId?: string;
  broId?: string;
  deliveryAccountableParty?: string;
  qualityRegime?: ApiGufIdsListQualityRegimeEnum;
  deliveryContext?: ApiGufIdsListDeliveryContextEnum;
  startTime?: string;
  endTime?: string;
  identificationLicence?: string;
  legalType?: ApiGufIdsListLegalTypeEnum;
  primaryUsageType?: ApiGufIdsListPrimaryUsageTypeEnum;
  secondaryUsageTypes?: string;
  humanConsumption?: ApiGufIdsListHumanConsumptionEnum;
  licensedQuantities?: string;
  dataOwner?: string;
  broIdIcontains?: string;
  page?: number;
}

export interface ApiGufInstallationsListRequest {
  uuid?: string;
  guf?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  designInstallationId?: string;
  installationFunction?: ApiGufInstallationsListInstallationFunctionEnum;
  designInstallationPos?: string;
  licensedQuantities?: string;
  page?: number;
}

export interface ApiGufInstallationsReadRequest {
  uuid: string;
}

export interface ApiGufLoopsListRequest {
  uuid?: string;
  installation?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  designLoopId?: string;
  loopType?: ApiGufLoopsListLoopTypeEnum;
  startDate?: string;
  endDate?: string;
  geometryType?: string;
  designLoopPos?: string;
  page?: number;
}

export interface ApiGufLoopsReadRequest {
  uuid: string;
}

export interface ApiGufSurfaceinfiltrationsListRequest {
  uuid?: string;
  installation?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  designSurfaceInfiltrationId?: string;
  designSurfaceInfiltrationPos?: string;
  page?: number;
}

export interface ApiGufSurfaceinfiltrationsReadRequest {
  uuid: string;
}

export interface ApiGufWellsListRequest {
  uuid?: string;
  installation?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  designWellId?: string;
  wellFunctions?: string;
  height?: string;
  wellPos?: string;
  geometryPubliclyAvailable?: ApiGufWellsListGeometryPubliclyAvailableEnum;
  maximumWellDepth?: string;
  maximumWellDepthPubliclyAvailable?: ApiGufWellsListMaximumWellDepthPubliclyAvailableEnum;
  maximumWellCapacity?: string;
  relativeTemperature?: ApiGufWellsListRelativeTemperatureEnum;
  designScreen?: string;
  page?: number;
}

export interface ApiGufWellsReadRequest {
  uuid: string;
}

export interface ApiImporttasksCreateRequest {
  data: Omit<ImportTask, "uuid" | "created" | "updated">;
}

export interface ApiImporttasksDeleteRequest {
  uuid: string;
}

export interface ApiImporttasksListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broDomain?: ApiImporttasksListBroDomainEnum;
  kvkNumber?: string;
  status?: ApiImporttasksListStatusEnum;
  log?: string;
  progress?: string;
  page?: number;
}

export interface ApiImporttasksPartialUpdateRequest {
  uuid: string;
  data: Omit<ImportTask, "uuid" | "created" | "updated">;
}

export interface ApiImporttasksReadRequest {
  uuid: string;
}

export interface ApiImporttasksUpdateRequest {
  uuid: string;
  data: Omit<ImportTask, "uuid" | "created" | "updated">;
}

export interface ApiObjectimporttasksCreateRequest {
  data: Omit<
    ObjectImportTask,
    "uuid" | "created" | "updated" | "bro_domain" | "status" | "log" | "data_owner"
  >;
}

export interface ApiObjectimporttasksListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broId?: string;
  broDomain?: ApiObjectimporttasksListBroDomainEnum;
  force?: string;
  status?: ApiObjectimporttasksListStatusEnum;
  log?: string;
  page?: number;
}

export interface ApiObjectimporttasksReadRequest {
  uuid: string;
}

export interface ApiOrganisationsListRequest {
  uuid?: string;
  name?: string;
  kvkNumber?: string;
  page?: number;
}

export interface ApiOrganisationsPartialUpdateRequest {
  uuid: string;
  data: FullOrganisation;
}

export interface ApiOrganisationsReadRequest {
  uuid: string;
}

export interface ApiUploadtasksCheckStatusRequest {
  uuid: string;
  data: Omit<UploadTask, "uuid" | "created" | "updated" | "data_owner">;
}

export interface ApiUploadtasksCreateRequest {
  data: Omit<UploadTask, "uuid" | "created" | "updated" | "data_owner">;
}

export interface ApiUploadtasksDeleteRequest {
  uuid: string;
}

export interface ApiUploadtasksListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broDomain?: ApiUploadtasksListBroDomainEnum;
  projectNumber?: string;
  registrationType?: ApiUploadtasksListRegistrationTypeEnum;
  requestType?: ApiUploadtasksListRequestTypeEnum;
  status?: ApiUploadtasksListStatusEnum;
  log?: string;
  broErrors?: string;
  progress?: string;
  broId?: string;
  broDeliveryUrl?: string;
  requestReferenceIcontains?: string;
  broIdIcontains?: string;
  registrationTypeIcontains?: string;
  createdLt?: string;
  createdLte?: string;
  createdGt?: string;
  createdGte?: string;
  updatedLt?: string;
  updatedLte?: string;
  updatedGt?: string;
  updatedGte?: string;
  page?: number;
}

export interface ApiUploadtasksOverviewListRequest {
  uuid?: string;
  created?: string;
  updated?: string;
  dataOwner?: string;
  broDomain?: ApiUploadtasksOverviewListBroDomainEnum;
  projectNumber?: string;
  registrationType?: ApiUploadtasksOverviewListRegistrationTypeEnum;
  requestType?: ApiUploadtasksOverviewListRequestTypeEnum;
  status?: ApiUploadtasksOverviewListStatusEnum;
  log?: string;
  broErrors?: string;
  progress?: string;
  broId?: string;
  broDeliveryUrl?: string;
  requestReferenceIcontains?: string;
  broIdIcontains?: string;
  registrationTypeIcontains?: string;
  createdLt?: string;
  createdLte?: string;
  createdGt?: string;
  createdGte?: string;
  updatedLt?: string;
  updatedLte?: string;
  updatedGt?: string;
  updatedGte?: string;
  page?: number;
}

export interface ApiUploadtasksPartialUpdateRequest {
  uuid: string;
  data: Omit<UploadTask, "uuid" | "created" | "updated" | "data_owner">;
}

export interface ApiUploadtasksReadRequest {
  uuid: string;
}

export interface ApiUploadtasksReadXmlRequest {
  uuid: string;
}

export interface ApiUploadtasksUpdateRequest {
  uuid: string;
  data: Omit<UploadTask, "uuid" | "created" | "updated" | "data_owner">;
}

export interface ApiUsersCreateRequest {
  data: User;
}

export interface ApiUsersDeleteRequest {
  id: string;
}

export interface ApiUsersListRequest {
  page?: number;
}

export interface ApiUsersLoggedInRequest {
  page?: number;
}

export interface ApiUsersPartialUpdateRequest {
  id: string;
  data: User;
}

export interface ApiUsersReadRequest {
  id: string;
}

export interface ApiUsersUpdateRequest {
  id: string;
  data: User;
}

/**
 *
 */
export class ApiApi extends runtime.BaseAPI {
  /**
   * Creates request options for apiBulkuploadsCreate without sending the request
   */
  async apiBulkuploadsCreateRequestOpts(
    requestParameters: ApiBulkuploadsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["projectNumber"] == null) {
      throw new runtime.RequiredError(
        "projectNumber",
        'Required parameter "projectNumber" was null or undefined when calling apiBulkuploadsCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["fieldworkFile"] != null) {
      formParams.append("fieldwork_file", requestParameters["fieldworkFile"] as any);
    }

    if (requestParameters["labFile"] != null) {
      formParams.append("lab_file", requestParameters["labFile"] as any);
    }

    if (requestParameters["measurementTvpFile"] != null) {
      formParams.append("measurement_tvp_file", requestParameters["measurementTvpFile"] as any);
    }

    if (requestParameters["projectNumber"] != null) {
      formParams.append("project_number", requestParameters["projectNumber"] as any);
    }

    if (requestParameters["bulkUploadType"] != null) {
      formParams.append("bulk_upload_type", requestParameters["bulkUploadType"] as any);
    }

    if (requestParameters["requestType"] != null) {
      formParams.append("request_type", requestParameters["requestType"] as any);
    }

    if (requestParameters["metadata"] != null) {
      formParams.append("metadata", requestParameters["metadata"] as any);
    }

    if (requestParameters["sourcedocumentData"] != null) {
      formParams.append("sourcedocument_data", requestParameters["sourcedocumentData"] as any);
    }

    if (requestParameters["status"] != null) {
      formParams.append("status", requestParameters["status"] as any);
    }

    if (requestParameters["log"] != null) {
      formParams.append("log", requestParameters["log"] as any);
    }

    if (requestParameters["progress"] != null) {
      formParams.append("progress", requestParameters["progress"] as any);
    }

    if (requestParameters["dataOwner"] != null) {
      formParams.append("data_owner", requestParameters["dataOwner"] as any);
    }

    let urlPath = `/api/bulkuploads/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsCreateRaw(
    requestParameters: ApiBulkuploadsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BulkUpload>> {
    const requestOptions = await this.apiBulkuploadsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BulkUploadFromJSON(jsonValue));
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsCreate(
    requestParameters: ApiBulkuploadsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BulkUpload> {
    const response = await this.apiBulkuploadsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiBulkuploadsDelete without sending the request
   */
  async apiBulkuploadsDeleteRequestOpts(
    requestParameters: ApiBulkuploadsDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiBulkuploadsDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/bulkuploads/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsDeleteRaw(
    requestParameters: ApiBulkuploadsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.apiBulkuploadsDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsDelete(
    requestParameters: ApiBulkuploadsDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.apiBulkuploadsDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for apiBulkuploadsList without sending the request
   */
  async apiBulkuploadsListRequestOpts(
    requestParameters: ApiBulkuploadsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/bulkuploads/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsListRaw(
    requestParameters: ApiBulkuploadsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiBulkuploadsList200Response>> {
    const requestOptions = await this.apiBulkuploadsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiBulkuploadsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsList(
    requestParameters: ApiBulkuploadsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiBulkuploadsList200Response> {
    const response = await this.apiBulkuploadsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiBulkuploadsPartialUpdate without sending the request
   */
  async apiBulkuploadsPartialUpdateRequestOpts(
    requestParameters: ApiBulkuploadsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiBulkuploadsPartialUpdate().'
      );
    }

    if (requestParameters["projectNumber"] == null) {
      throw new runtime.RequiredError(
        "projectNumber",
        'Required parameter "projectNumber" was null or undefined when calling apiBulkuploadsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["fieldworkFile"] != null) {
      formParams.append("fieldwork_file", requestParameters["fieldworkFile"] as any);
    }

    if (requestParameters["labFile"] != null) {
      formParams.append("lab_file", requestParameters["labFile"] as any);
    }

    if (requestParameters["measurementTvpFile"] != null) {
      formParams.append("measurement_tvp_file", requestParameters["measurementTvpFile"] as any);
    }

    if (requestParameters["projectNumber"] != null) {
      formParams.append("project_number", requestParameters["projectNumber"] as any);
    }

    if (requestParameters["bulkUploadType"] != null) {
      formParams.append("bulk_upload_type", requestParameters["bulkUploadType"] as any);
    }

    if (requestParameters["requestType"] != null) {
      formParams.append("request_type", requestParameters["requestType"] as any);
    }

    if (requestParameters["metadata"] != null) {
      formParams.append("metadata", requestParameters["metadata"] as any);
    }

    if (requestParameters["sourcedocumentData"] != null) {
      formParams.append("sourcedocument_data", requestParameters["sourcedocumentData"] as any);
    }

    if (requestParameters["status"] != null) {
      formParams.append("status", requestParameters["status"] as any);
    }

    if (requestParameters["log"] != null) {
      formParams.append("log", requestParameters["log"] as any);
    }

    if (requestParameters["progress"] != null) {
      formParams.append("progress", requestParameters["progress"] as any);
    }

    if (requestParameters["dataOwner"] != null) {
      formParams.append("data_owner", requestParameters["dataOwner"] as any);
    }

    let urlPath = `/api/bulkuploads/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsPartialUpdateRaw(
    requestParameters: ApiBulkuploadsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BulkUpload>> {
    const requestOptions = await this.apiBulkuploadsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BulkUploadFromJSON(jsonValue));
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsPartialUpdate(
    requestParameters: ApiBulkuploadsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BulkUpload> {
    const response = await this.apiBulkuploadsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiBulkuploadsRead without sending the request
   */
  async apiBulkuploadsReadRequestOpts(
    requestParameters: ApiBulkuploadsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiBulkuploadsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/bulkuploads/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsReadRaw(
    requestParameters: ApiBulkuploadsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BulkUpload>> {
    const requestOptions = await this.apiBulkuploadsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BulkUploadFromJSON(jsonValue));
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsRead(
    requestParameters: ApiBulkuploadsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BulkUpload> {
    const response = await this.apiBulkuploadsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiBulkuploadsUpdate without sending the request
   */
  async apiBulkuploadsUpdateRequestOpts(
    requestParameters: ApiBulkuploadsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiBulkuploadsUpdate().'
      );
    }

    if (requestParameters["projectNumber"] == null) {
      throw new runtime.RequiredError(
        "projectNumber",
        'Required parameter "projectNumber" was null or undefined when calling apiBulkuploadsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["fieldworkFile"] != null) {
      formParams.append("fieldwork_file", requestParameters["fieldworkFile"] as any);
    }

    if (requestParameters["labFile"] != null) {
      formParams.append("lab_file", requestParameters["labFile"] as any);
    }

    if (requestParameters["measurementTvpFile"] != null) {
      formParams.append("measurement_tvp_file", requestParameters["measurementTvpFile"] as any);
    }

    if (requestParameters["projectNumber"] != null) {
      formParams.append("project_number", requestParameters["projectNumber"] as any);
    }

    if (requestParameters["bulkUploadType"] != null) {
      formParams.append("bulk_upload_type", requestParameters["bulkUploadType"] as any);
    }

    if (requestParameters["requestType"] != null) {
      formParams.append("request_type", requestParameters["requestType"] as any);
    }

    if (requestParameters["metadata"] != null) {
      formParams.append("metadata", requestParameters["metadata"] as any);
    }

    if (requestParameters["sourcedocumentData"] != null) {
      formParams.append("sourcedocument_data", requestParameters["sourcedocumentData"] as any);
    }

    if (requestParameters["status"] != null) {
      formParams.append("status", requestParameters["status"] as any);
    }

    if (requestParameters["log"] != null) {
      formParams.append("log", requestParameters["log"] as any);
    }

    if (requestParameters["progress"] != null) {
      formParams.append("progress", requestParameters["progress"] as any);
    }

    if (requestParameters["dataOwner"] != null) {
      formParams.append("data_owner", requestParameters["dataOwner"] as any);
    }

    let urlPath = `/api/bulkuploads/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsUpdateRaw(
    requestParameters: ApiBulkuploadsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BulkUpload>> {
    const requestOptions = await this.apiBulkuploadsUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => BulkUploadFromJSON(jsonValue));
  }

  /**
   * This endpoint interfaces with the BulkUpload model and supports the following POST parameters:  `bulk_upload_type`:     str (*required*): Options: [\'GAR\', \'GLD\', \'GMN\']  `metadata`:     json (*optional*): Open json field that can be filled in with information that cannot be provided through the upload files  `files`:     file (*required*): Accepts one or more files in either Excel or CSV format.        When the bulk_upload_type is GAR, these 2 files are required:         - fieldwork_file         - lab_file      When the bulk_upload_type is GLD or GMN, this 1 file is required:         - measurement_tvp_file
   * Endpoint that handles the bulk uploads of files and related data.
   */
  async apiBulkuploadsUpdate(
    requestParameters: ApiBulkuploadsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BulkUpload> {
    const response = await this.apiBulkuploadsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiFrdFrdsList without sending the request
   */
  async apiFrdFrdsListRequestOpts(
    requestParameters: ApiFrdFrdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["linkedGmns"] != null) {
      queryParameters["linked_gmns"] = requestParameters["linkedGmns"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["determinationType"] != null) {
      queryParameters["determination_type"] = requestParameters["determinationType"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["researchFirstDate"] != null) {
      queryParameters["research_first_date"] = requestParameters["researchFirstDate"];
    }

    if (requestParameters["researchLastDate"] != null) {
      queryParameters["research_last_date"] = requestParameters["researchLastDate"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["gmwBroIdIcontains"] != null) {
      queryParameters["gmw_bro_id__icontains"] = requestParameters["gmwBroIdIcontains"];
    }

    if (requestParameters["gmw"] != null) {
      queryParameters["gmw"] = requestParameters["gmw"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/frds/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of FRD objects for the user\'s organization.
   */
  async apiFrdFrdsListRaw(
    requestParameters: ApiFrdFrdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiFrdFrdsList200Response>> {
    const requestOptions = await this.apiFrdFrdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiFrdFrdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of FRD objects for the user\'s organization.
   */
  async apiFrdFrdsList(
    requestParameters: ApiFrdFrdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiFrdFrdsList200Response> {
    const response = await this.apiFrdFrdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiFrdFrdsRead without sending the request
   */
  async apiFrdFrdsReadRequestOpts(
    requestParameters: ApiFrdFrdsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiFrdFrdsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/frds/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single FRD object by UUID.
   */
  async apiFrdFrdsReadRaw(
    requestParameters: ApiFrdFrdsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FRD>> {
    const requestOptions = await this.apiFrdFrdsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FRDFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single FRD object by UUID.
   */
  async apiFrdFrdsRead(
    requestParameters: ApiFrdFrdsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FRD> {
    const response = await this.apiFrdFrdsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiFrdGeoelectricmeasurementsList without sending the request
   */
  async apiFrdGeoelectricmeasurementsListRequestOpts(
    requestParameters: ApiFrdGeoelectricmeasurementsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["frd"] != null) {
      queryParameters["frd"] = requestParameters["frd"];
    }

    if (requestParameters["measurementDate"] != null) {
      queryParameters["measurement_date"] = requestParameters["measurementDate"];
    }

    if (requestParameters["determinationProcedure"] != null) {
      queryParameters["determination_procedure"] = requestParameters["determinationProcedure"];
    }

    if (requestParameters["evaluationProcedure"] != null) {
      queryParameters["evaluation_procedure"] = requestParameters["evaluationProcedure"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/geoelectricmeasurements/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GeoElectricMeasurement objects for the user\'s organization.
   */
  async apiFrdGeoelectricmeasurementsListRaw(
    requestParameters: ApiFrdGeoelectricmeasurementsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiFrdGeoelectricmeasurementsList200Response>> {
    const requestOptions = await this.apiFrdGeoelectricmeasurementsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiFrdGeoelectricmeasurementsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GeoElectricMeasurement objects for the user\'s organization.
   */
  async apiFrdGeoelectricmeasurementsList(
    requestParameters: ApiFrdGeoelectricmeasurementsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiFrdGeoelectricmeasurementsList200Response> {
    const response = await this.apiFrdGeoelectricmeasurementsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for apiFrdGeoelectricmeasurementsRead without sending the request
   */
  async apiFrdGeoelectricmeasurementsReadRequestOpts(
    requestParameters: ApiFrdGeoelectricmeasurementsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiFrdGeoelectricmeasurementsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/geoelectricmeasurements/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GeoElectricMeasurement object by UUID.
   */
  async apiFrdGeoelectricmeasurementsReadRaw(
    requestParameters: ApiFrdGeoelectricmeasurementsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GeoElectricMeasurement>> {
    const requestOptions = await this.apiFrdGeoelectricmeasurementsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GeoElectricMeasurementFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single GeoElectricMeasurement object by UUID.
   */
  async apiFrdGeoelectricmeasurementsRead(
    requestParameters: ApiFrdGeoelectricmeasurementsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GeoElectricMeasurement> {
    const response = await this.apiFrdGeoelectricmeasurementsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for apiFrdGeoelectricmeasuresList without sending the request
   */
  async apiFrdGeoelectricmeasuresListRequestOpts(
    requestParameters: ApiFrdGeoelectricmeasuresListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["geoElectricMeasurement"] != null) {
      queryParameters["geo_electric_measurement"] = requestParameters["geoElectricMeasurement"];
    }

    if (requestParameters["resistance"] != null) {
      queryParameters["resistance"] = requestParameters["resistance"];
    }

    if (requestParameters["relatedMeasurementConfiguration"] != null) {
      queryParameters["related_measurement_configuration"] =
        requestParameters["relatedMeasurementConfiguration"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/geoelectricmeasures/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GeoElectricMeasure objects for the user\'s organization.
   */
  async apiFrdGeoelectricmeasuresListRaw(
    requestParameters: ApiFrdGeoelectricmeasuresListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiFrdGeoelectricmeasuresList200Response>> {
    const requestOptions = await this.apiFrdGeoelectricmeasuresListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiFrdGeoelectricmeasuresList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GeoElectricMeasure objects for the user\'s organization.
   */
  async apiFrdGeoelectricmeasuresList(
    requestParameters: ApiFrdGeoelectricmeasuresListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiFrdGeoelectricmeasuresList200Response> {
    const response = await this.apiFrdGeoelectricmeasuresListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiFrdGeoelectricmeasuresRead without sending the request
   */
  async apiFrdGeoelectricmeasuresReadRequestOpts(
    requestParameters: ApiFrdGeoelectricmeasuresReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiFrdGeoelectricmeasuresRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/geoelectricmeasures/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GeoElectricMeasure object by UUID.
   */
  async apiFrdGeoelectricmeasuresReadRaw(
    requestParameters: ApiFrdGeoelectricmeasuresReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GeoElectricMeasure>> {
    const requestOptions = await this.apiFrdGeoelectricmeasuresReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GeoElectricMeasureFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single GeoElectricMeasure object by UUID.
   */
  async apiFrdGeoelectricmeasuresRead(
    requestParameters: ApiFrdGeoelectricmeasuresReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GeoElectricMeasure> {
    const response = await this.apiFrdGeoelectricmeasuresReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiFrdIdsList without sending the request
   */
  async apiFrdIdsListRequestOpts(
    requestParameters: ApiFrdIdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["linkedGmns"] != null) {
      queryParameters["linked_gmns"] = requestParameters["linkedGmns"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["determinationType"] != null) {
      queryParameters["determination_type"] = requestParameters["determinationType"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["researchFirstDate"] != null) {
      queryParameters["research_first_date"] = requestParameters["researchFirstDate"];
    }

    if (requestParameters["researchLastDate"] != null) {
      queryParameters["research_last_date"] = requestParameters["researchLastDate"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["gmwBroIdIcontains"] != null) {
      queryParameters["gmw_bro_id__icontains"] = requestParameters["gmwBroIdIcontains"];
    }

    if (requestParameters["gmw"] != null) {
      queryParameters["gmw"] = requestParameters["gmw"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/ids/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of FRD IDs for the user\'s organization.
   */
  async apiFrdIdsListRaw(
    requestParameters: ApiFrdIdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiFrdIdsList200Response>> {
    const requestOptions = await this.apiFrdIdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiFrdIdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of FRD IDs for the user\'s organization.
   */
  async apiFrdIdsList(
    requestParameters: ApiFrdIdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiFrdIdsList200Response> {
    const response = await this.apiFrdIdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiFrdMeasurementconfigurationsList without sending the request
   */
  async apiFrdMeasurementconfigurationsListRequestOpts(
    requestParameters: ApiFrdMeasurementconfigurationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["frd"] != null) {
      queryParameters["frd"] = requestParameters["frd"];
    }

    if (requestParameters["measurementConfigurationId"] != null) {
      queryParameters["measurement_configuration_id"] =
        requestParameters["measurementConfigurationId"];
    }

    if (requestParameters["measurementPair"] != null) {
      queryParameters["measurement_pair"] = requestParameters["measurementPair"];
    }

    if (requestParameters["currentPair"] != null) {
      queryParameters["current_pair"] = requestParameters["currentPair"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/measurementconfigurations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of MeasurementConfiguration objects for the user\'s organization.
   */
  async apiFrdMeasurementconfigurationsListRaw(
    requestParameters: ApiFrdMeasurementconfigurationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiFrdMeasurementconfigurationsList200Response>> {
    const requestOptions = await this.apiFrdMeasurementconfigurationsListRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiFrdMeasurementconfigurationsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of MeasurementConfiguration objects for the user\'s organization.
   */
  async apiFrdMeasurementconfigurationsList(
    requestParameters: ApiFrdMeasurementconfigurationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiFrdMeasurementconfigurationsList200Response> {
    const response = await this.apiFrdMeasurementconfigurationsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for apiFrdMeasurementconfigurationsRead without sending the request
   */
  async apiFrdMeasurementconfigurationsReadRequestOpts(
    requestParameters: ApiFrdMeasurementconfigurationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiFrdMeasurementconfigurationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/frd/measurementconfigurations/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single MeasurementConfiguration object by UUID.
   */
  async apiFrdMeasurementconfigurationsReadRaw(
    requestParameters: ApiFrdMeasurementconfigurationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MeasurementConfiguration>> {
    const requestOptions = await this.apiFrdMeasurementconfigurationsReadRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MeasurementConfigurationFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single MeasurementConfiguration object by UUID.
   */
  async apiFrdMeasurementconfigurationsRead(
    requestParameters: ApiFrdMeasurementconfigurationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MeasurementConfiguration> {
    const response = await this.apiFrdMeasurementconfigurationsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for apiGarAnalysesList without sending the request
   */
  async apiGarAnalysesListRequestOpts(
    requestParameters: ApiGarAnalysesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["analysisProcess"] != null) {
      queryParameters["analysis_process"] = requestParameters["analysisProcess"];
    }

    if (requestParameters["parameter"] != null) {
      queryParameters["parameter"] = requestParameters["parameter"];
    }

    if (requestParameters["limitSymbol"] != null) {
      queryParameters["limit_symbol"] = requestParameters["limitSymbol"];
    }

    if (requestParameters["unit"] != null) {
      queryParameters["unit"] = requestParameters["unit"];
    }

    if (requestParameters["value"] != null) {
      queryParameters["value"] = requestParameters["value"];
    }

    if (requestParameters["reportingLimit"] != null) {
      queryParameters["reporting_limit"] = requestParameters["reportingLimit"];
    }

    if (requestParameters["statusQualityControl"] != null) {
      queryParameters["status_quality_control"] = requestParameters["statusQualityControl"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/analyses/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of Analysis objects for the user\'s organization.
   */
  async apiGarAnalysesListRaw(
    requestParameters: ApiGarAnalysesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGarAnalysesList200Response>> {
    const requestOptions = await this.apiGarAnalysesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGarAnalysesList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of Analysis objects for the user\'s organization.
   */
  async apiGarAnalysesList(
    requestParameters: ApiGarAnalysesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGarAnalysesList200Response> {
    const response = await this.apiGarAnalysesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarAnalysesRead without sending the request
   */
  async apiGarAnalysesReadRequestOpts(
    requestParameters: ApiGarAnalysesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGarAnalysesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/analyses/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single Analysis object by UUID.
   */
  async apiGarAnalysesReadRaw(
    requestParameters: ApiGarAnalysesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Analysis>> {
    const requestOptions = await this.apiGarAnalysesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => AnalysisFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single Analysis object by UUID.
   */
  async apiGarAnalysesRead(
    requestParameters: ApiGarAnalysesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Analysis> {
    const response = await this.apiGarAnalysesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarAnalysisprocessesList without sending the request
   */
  async apiGarAnalysisprocessesListRequestOpts(
    requestParameters: ApiGarAnalysisprocessesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["laboratoryResearch"] != null) {
      queryParameters["laboratory_research"] = requestParameters["laboratoryResearch"];
    }

    if (requestParameters["analysesDate"] != null) {
      queryParameters["analyses_date"] = requestParameters["analysesDate"];
    }

    if (requestParameters["analyticalTechnique"] != null) {
      queryParameters["analytical_technique"] = requestParameters["analyticalTechnique"];
    }

    if (requestParameters["validationMethod"] != null) {
      queryParameters["validation_method"] = requestParameters["validationMethod"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/analysisprocesses/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of AnalysisProcess objects for the user\'s organization.
   */
  async apiGarAnalysisprocessesListRaw(
    requestParameters: ApiGarAnalysisprocessesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGarAnalysisprocessesList200Response>> {
    const requestOptions = await this.apiGarAnalysisprocessesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGarAnalysisprocessesList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of AnalysisProcess objects for the user\'s organization.
   */
  async apiGarAnalysisprocessesList(
    requestParameters: ApiGarAnalysisprocessesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGarAnalysisprocessesList200Response> {
    const response = await this.apiGarAnalysisprocessesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarAnalysisprocessesRead without sending the request
   */
  async apiGarAnalysisprocessesReadRequestOpts(
    requestParameters: ApiGarAnalysisprocessesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGarAnalysisprocessesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/analysisprocesses/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single AnalysisProcess object by UUID.
   */
  async apiGarAnalysisprocessesReadRaw(
    requestParameters: ApiGarAnalysisprocessesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AnalysisProcess>> {
    const requestOptions = await this.apiGarAnalysisprocessesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => AnalysisProcessFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single AnalysisProcess object by UUID.
   */
  async apiGarAnalysisprocessesRead(
    requestParameters: ApiGarAnalysisprocessesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AnalysisProcess> {
    const response = await this.apiGarAnalysisprocessesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarFieldmeasurementsList without sending the request
   */
  async apiGarFieldmeasurementsListRequestOpts(
    requestParameters: ApiGarFieldmeasurementsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["gar"] != null) {
      queryParameters["gar"] = requestParameters["gar"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["parameter"] != null) {
      queryParameters["parameter"] = requestParameters["parameter"];
    }

    if (requestParameters["unit"] != null) {
      queryParameters["unit"] = requestParameters["unit"];
    }

    if (requestParameters["fieldMeasurementValue"] != null) {
      queryParameters["field_measurement_value"] = requestParameters["fieldMeasurementValue"];
    }

    if (requestParameters["qualityControlStatus"] != null) {
      queryParameters["quality_control_status"] = requestParameters["qualityControlStatus"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/fieldmeasurements/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of FieldMeasurement objects for the user\'s organization.
   */
  async apiGarFieldmeasurementsListRaw(
    requestParameters: ApiGarFieldmeasurementsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGarFieldmeasurementsList200Response>> {
    const requestOptions = await this.apiGarFieldmeasurementsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGarFieldmeasurementsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of FieldMeasurement objects for the user\'s organization.
   */
  async apiGarFieldmeasurementsList(
    requestParameters: ApiGarFieldmeasurementsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGarFieldmeasurementsList200Response> {
    const response = await this.apiGarFieldmeasurementsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarFieldmeasurementsRead without sending the request
   */
  async apiGarFieldmeasurementsReadRequestOpts(
    requestParameters: ApiGarFieldmeasurementsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGarFieldmeasurementsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/fieldmeasurements/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single FieldMeasurement object by UUID.
   */
  async apiGarFieldmeasurementsReadRaw(
    requestParameters: ApiGarFieldmeasurementsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FieldMeasurement>> {
    const requestOptions = await this.apiGarFieldmeasurementsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FieldMeasurementFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single FieldMeasurement object by UUID.
   */
  async apiGarFieldmeasurementsRead(
    requestParameters: ApiGarFieldmeasurementsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FieldMeasurement> {
    const response = await this.apiGarFieldmeasurementsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarGarsList without sending the request
   */
  async apiGarGarsListRequestOpts(
    requestParameters: ApiGarGarsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["qualityControlMethod"] != null) {
      queryParameters["quality_control_method"] = requestParameters["qualityControlMethod"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["samplingDatetime"] != null) {
      queryParameters["sampling_datetime"] = requestParameters["samplingDatetime"];
    }

    if (requestParameters["samplingStandard"] != null) {
      queryParameters["sampling_standard"] = requestParameters["samplingStandard"];
    }

    if (requestParameters["primaryColour"] != null) {
      queryParameters["primary_colour"] = requestParameters["primaryColour"];
    }

    if (requestParameters["secondaryColour"] != null) {
      queryParameters["secondary_colour"] = requestParameters["secondaryColour"];
    }

    if (requestParameters["colourStrength"] != null) {
      queryParameters["colour_strength"] = requestParameters["colourStrength"];
    }

    if (requestParameters["pumpType"] != null) {
      queryParameters["pump_type"] = requestParameters["pumpType"];
    }

    if (requestParameters["abnormalityInCooling"] != null) {
      queryParameters["abnormality_in_cooling"] = requestParameters["abnormalityInCooling"];
    }

    if (requestParameters["abnormalityInDevice"] != null) {
      queryParameters["abnormality_in_device"] = requestParameters["abnormalityInDevice"];
    }

    if (requestParameters["pollutedByEngine"] != null) {
      queryParameters["polluted_by_engine"] = requestParameters["pollutedByEngine"];
    }

    if (requestParameters["filterAerated"] != null) {
      queryParameters["filter_aerated"] = requestParameters["filterAerated"];
    }

    if (requestParameters["groundwaterLevelDroppedTooMuch"] != null) {
      queryParameters["groundwater_level_dropped_too_much"] =
        requestParameters["groundwaterLevelDroppedTooMuch"];
    }

    if (requestParameters["abnormalFilter"] != null) {
      queryParameters["abnormal_filter"] = requestParameters["abnormalFilter"];
    }

    if (requestParameters["sampleAerated"] != null) {
      queryParameters["sample_aerated"] = requestParameters["sampleAerated"];
    }

    if (requestParameters["hoseReused"] != null) {
      queryParameters["hose_reused"] = requestParameters["hoseReused"];
    }

    if (requestParameters["temperatureDifficultToMeasure"] != null) {
      queryParameters["temperature_difficult_to_measure"] =
        requestParameters["temperatureDifficultToMeasure"];
    }

    if (requestParameters["labAnalysisDate"] != null) {
      queryParameters["lab_analysis_date"] = requestParameters["labAnalysisDate"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["gmwBroIdIcontains"] != null) {
      queryParameters["gmw_bro_id__icontains"] = requestParameters["gmwBroIdIcontains"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/gars/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GAR objects for the user\'s organization.
   */
  async apiGarGarsListRaw(
    requestParameters: ApiGarGarsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGarGarsList200Response>> {
    const requestOptions = await this.apiGarGarsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGarGarsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GAR objects for the user\'s organization.
   */
  async apiGarGarsList(
    requestParameters: ApiGarGarsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGarGarsList200Response> {
    const response = await this.apiGarGarsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarGarsRead without sending the request
   */
  async apiGarGarsReadRequestOpts(
    requestParameters: ApiGarGarsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGarGarsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/gars/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GAR object by UUID.
   */
  async apiGarGarsReadRaw(
    requestParameters: ApiGarGarsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GAR>> {
    const requestOptions = await this.apiGarGarsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => GARFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single GAR object by UUID.
   */
  async apiGarGarsRead(
    requestParameters: ApiGarGarsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GAR> {
    const response = await this.apiGarGarsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarIdsList without sending the request
   */
  async apiGarIdsListRequestOpts(
    requestParameters: ApiGarIdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["qualityControlMethod"] != null) {
      queryParameters["quality_control_method"] = requestParameters["qualityControlMethod"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["samplingDatetime"] != null) {
      queryParameters["sampling_datetime"] = requestParameters["samplingDatetime"];
    }

    if (requestParameters["samplingStandard"] != null) {
      queryParameters["sampling_standard"] = requestParameters["samplingStandard"];
    }

    if (requestParameters["primaryColour"] != null) {
      queryParameters["primary_colour"] = requestParameters["primaryColour"];
    }

    if (requestParameters["secondaryColour"] != null) {
      queryParameters["secondary_colour"] = requestParameters["secondaryColour"];
    }

    if (requestParameters["colourStrength"] != null) {
      queryParameters["colour_strength"] = requestParameters["colourStrength"];
    }

    if (requestParameters["pumpType"] != null) {
      queryParameters["pump_type"] = requestParameters["pumpType"];
    }

    if (requestParameters["abnormalityInCooling"] != null) {
      queryParameters["abnormality_in_cooling"] = requestParameters["abnormalityInCooling"];
    }

    if (requestParameters["abnormalityInDevice"] != null) {
      queryParameters["abnormality_in_device"] = requestParameters["abnormalityInDevice"];
    }

    if (requestParameters["pollutedByEngine"] != null) {
      queryParameters["polluted_by_engine"] = requestParameters["pollutedByEngine"];
    }

    if (requestParameters["filterAerated"] != null) {
      queryParameters["filter_aerated"] = requestParameters["filterAerated"];
    }

    if (requestParameters["groundwaterLevelDroppedTooMuch"] != null) {
      queryParameters["groundwater_level_dropped_too_much"] =
        requestParameters["groundwaterLevelDroppedTooMuch"];
    }

    if (requestParameters["abnormalFilter"] != null) {
      queryParameters["abnormal_filter"] = requestParameters["abnormalFilter"];
    }

    if (requestParameters["sampleAerated"] != null) {
      queryParameters["sample_aerated"] = requestParameters["sampleAerated"];
    }

    if (requestParameters["hoseReused"] != null) {
      queryParameters["hose_reused"] = requestParameters["hoseReused"];
    }

    if (requestParameters["temperatureDifficultToMeasure"] != null) {
      queryParameters["temperature_difficult_to_measure"] =
        requestParameters["temperatureDifficultToMeasure"];
    }

    if (requestParameters["labAnalysisDate"] != null) {
      queryParameters["lab_analysis_date"] = requestParameters["labAnalysisDate"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["gmwBroIdIcontains"] != null) {
      queryParameters["gmw_bro_id__icontains"] = requestParameters["gmwBroIdIcontains"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/ids/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GAR IDs for the user\'s organization.
   */
  async apiGarIdsListRaw(
    requestParameters: ApiGarIdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGarIdsList200Response>> {
    const requestOptions = await this.apiGarIdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGarIdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GAR IDs for the user\'s organization.
   */
  async apiGarIdsList(
    requestParameters: ApiGarIdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGarIdsList200Response> {
    const response = await this.apiGarIdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarLaboratoryresearchesList without sending the request
   */
  async apiGarLaboratoryresearchesListRequestOpts(
    requestParameters: ApiGarLaboratoryresearchesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["gar"] != null) {
      queryParameters["gar"] = requestParameters["gar"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["laboratoryKvkNumber"] != null) {
      queryParameters["laboratory_kvk_number"] = requestParameters["laboratoryKvkNumber"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/laboratoryresearches/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of LaboratoryResearch objects for the user\'s organization.
   */
  async apiGarLaboratoryresearchesListRaw(
    requestParameters: ApiGarLaboratoryresearchesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGarLaboratoryresearchesList200Response>> {
    const requestOptions = await this.apiGarLaboratoryresearchesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGarLaboratoryresearchesList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of LaboratoryResearch objects for the user\'s organization.
   */
  async apiGarLaboratoryresearchesList(
    requestParameters: ApiGarLaboratoryresearchesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGarLaboratoryresearchesList200Response> {
    const response = await this.apiGarLaboratoryresearchesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGarLaboratoryresearchesRead without sending the request
   */
  async apiGarLaboratoryresearchesReadRequestOpts(
    requestParameters: ApiGarLaboratoryresearchesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGarLaboratoryresearchesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gar/laboratoryresearches/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single LaboratoryResearch object by UUID.
   */
  async apiGarLaboratoryresearchesReadRaw(
    requestParameters: ApiGarLaboratoryresearchesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<LaboratoryResearch>> {
    const requestOptions = await this.apiGarLaboratoryresearchesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LaboratoryResearchFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single LaboratoryResearch object by UUID.
   */
  async apiGarLaboratoryresearchesRead(
    requestParameters: ApiGarLaboratoryresearchesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<LaboratoryResearch> {
    const response = await this.apiGarLaboratoryresearchesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGldGldsList without sending the request
   */
  async apiGldGldsListRequestOpts(
    requestParameters: ApiGldGldsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["linkedGmns"] != null) {
      queryParameters["linked_gmns"] = requestParameters["linkedGmns"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["researchFirstDate"] != null) {
      queryParameters["research_first_date"] = requestParameters["researchFirstDate"];
    }

    if (requestParameters["researchLastDate"] != null) {
      queryParameters["research_last_date"] = requestParameters["researchLastDate"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["researchFirstDateGt"] != null) {
      queryParameters["research_first_date__gt"] = requestParameters["researchFirstDateGt"];
    }

    if (requestParameters["researchFirstDateGte"] != null) {
      queryParameters["research_first_date__gte"] = requestParameters["researchFirstDateGte"];
    }

    if (requestParameters["researchFirstDateLt"] != null) {
      queryParameters["research_first_date__lt"] = requestParameters["researchFirstDateLt"];
    }

    if (requestParameters["researchFirstDateLte"] != null) {
      queryParameters["research_first_date__lte"] = requestParameters["researchFirstDateLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gld/glds/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GLD objects for the user\'s organization.
   */
  async apiGldGldsListRaw(
    requestParameters: ApiGldGldsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGldGldsList200Response>> {
    const requestOptions = await this.apiGldGldsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGldGldsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GLD objects for the user\'s organization.
   */
  async apiGldGldsList(
    requestParameters: ApiGldGldsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGldGldsList200Response> {
    const response = await this.apiGldGldsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGldGldsRead without sending the request
   */
  async apiGldGldsReadRequestOpts(
    requestParameters: ApiGldGldsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGldGldsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gld/glds/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GLD object by UUID.
   */
  async apiGldGldsReadRaw(
    requestParameters: ApiGldGldsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GLD>> {
    const requestOptions = await this.apiGldGldsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => GLDFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single GLD object by UUID.
   */
  async apiGldGldsRead(
    requestParameters: ApiGldGldsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GLD> {
    const response = await this.apiGldGldsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGldIdsList without sending the request
   */
  async apiGldIdsListRequestOpts(
    requestParameters: ApiGldIdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["linkedGmns"] != null) {
      queryParameters["linked_gmns"] = requestParameters["linkedGmns"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["researchFirstDate"] != null) {
      queryParameters["research_first_date"] = requestParameters["researchFirstDate"];
    }

    if (requestParameters["researchLastDate"] != null) {
      queryParameters["research_last_date"] = requestParameters["researchLastDate"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["researchFirstDateGt"] != null) {
      queryParameters["research_first_date__gt"] = requestParameters["researchFirstDateGt"];
    }

    if (requestParameters["researchFirstDateGte"] != null) {
      queryParameters["research_first_date__gte"] = requestParameters["researchFirstDateGte"];
    }

    if (requestParameters["researchFirstDateLt"] != null) {
      queryParameters["research_first_date__lt"] = requestParameters["researchFirstDateLt"];
    }

    if (requestParameters["researchFirstDateLte"] != null) {
      queryParameters["research_first_date__lte"] = requestParameters["researchFirstDateLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gld/ids/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GLD IDs for the user\'s organization.
   */
  async apiGldIdsListRaw(
    requestParameters: ApiGldIdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGldIdsList200Response>> {
    const requestOptions = await this.apiGldIdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGldIdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GLD IDs for the user\'s organization.
   */
  async apiGldIdsList(
    requestParameters: ApiGldIdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGldIdsList200Response> {
    const response = await this.apiGldIdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGldObservationsList without sending the request
   */
  async apiGldObservationsListRequestOpts(
    requestParameters: ApiGldObservationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["gld"] != null) {
      queryParameters["gld"] = requestParameters["gld"];
    }

    if (requestParameters["observationId"] != null) {
      queryParameters["observation_id"] = requestParameters["observationId"];
    }

    if (requestParameters["beginPosition"] != null) {
      queryParameters["begin_position"] = requestParameters["beginPosition"];
    }

    if (requestParameters["endPosition"] != null) {
      queryParameters["end_position"] = requestParameters["endPosition"];
    }

    if (requestParameters["resultTime"] != null) {
      queryParameters["result_time"] = requestParameters["resultTime"];
    }

    if (requestParameters["validationStatus"] != null) {
      queryParameters["validation_status"] = requestParameters["validationStatus"];
    }

    if (requestParameters["investigatorKvk"] != null) {
      queryParameters["investigator_kvk"] = requestParameters["investigatorKvk"];
    }

    if (requestParameters["observationType"] != null) {
      queryParameters["observation_type"] = requestParameters["observationType"];
    }

    if (requestParameters["processReference"] != null) {
      queryParameters["process_reference"] = requestParameters["processReference"];
    }

    if (requestParameters["airPressureCompensationType"] != null) {
      queryParameters["air_pressure_compensation_type"] =
        requestParameters["airPressureCompensationType"];
    }

    if (requestParameters["evaluationProcedure"] != null) {
      queryParameters["evaluation_procedure"] = requestParameters["evaluationProcedure"];
    }

    if (requestParameters["measurementInstrumentType"] != null) {
      queryParameters["measurement_instrument_type"] =
        requestParameters["measurementInstrumentType"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["beginPositionGt"] != null) {
      queryParameters["begin_position__gt"] = requestParameters["beginPositionGt"];
    }

    if (requestParameters["beginPositionGte"] != null) {
      queryParameters["begin_position__gte"] = requestParameters["beginPositionGte"];
    }

    if (requestParameters["beginPositionLt"] != null) {
      queryParameters["begin_position__lt"] = requestParameters["beginPositionLt"];
    }

    if (requestParameters["beginPositionLte"] != null) {
      queryParameters["begin_position__lte"] = requestParameters["beginPositionLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gld/observations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of Observation objects for the user\'s organization.
   */
  async apiGldObservationsListRaw(
    requestParameters: ApiGldObservationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGldObservationsList200Response>> {
    const requestOptions = await this.apiGldObservationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGldObservationsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of Observation objects for the user\'s organization.
   */
  async apiGldObservationsList(
    requestParameters: ApiGldObservationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGldObservationsList200Response> {
    const response = await this.apiGldObservationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGldObservationsRead without sending the request
   */
  async apiGldObservationsReadRequestOpts(
    requestParameters: ApiGldObservationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGldObservationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gld/observations/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single Observation object by UUID.
   */
  async apiGldObservationsReadRaw(
    requestParameters: ApiGldObservationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Observation>> {
    const requestOptions = await this.apiGldObservationsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ObservationFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single Observation object by UUID.
   */
  async apiGldObservationsRead(
    requestParameters: ApiGldObservationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Observation> {
    const response = await this.apiGldObservationsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGldOverviewList without sending the request
   */
  async apiGldOverviewListRequestOpts(
    requestParameters: ApiGldOverviewListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["linkedGmns"] != null) {
      queryParameters["linked_gmns"] = requestParameters["linkedGmns"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["researchFirstDate"] != null) {
      queryParameters["research_first_date"] = requestParameters["researchFirstDate"];
    }

    if (requestParameters["researchLastDate"] != null) {
      queryParameters["research_last_date"] = requestParameters["researchLastDate"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["researchFirstDateGt"] != null) {
      queryParameters["research_first_date__gt"] = requestParameters["researchFirstDateGt"];
    }

    if (requestParameters["researchFirstDateGte"] != null) {
      queryParameters["research_first_date__gte"] = requestParameters["researchFirstDateGte"];
    }

    if (requestParameters["researchFirstDateLt"] != null) {
      queryParameters["research_first_date__lt"] = requestParameters["researchFirstDateLt"];
    }

    if (requestParameters["researchFirstDateLte"] != null) {
      queryParameters["research_first_date__lte"] = requestParameters["researchFirstDateLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gld/overview/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve an overview list of GLD objects for the user\'s organization.
   */
  async apiGldOverviewListRaw(
    requestParameters: ApiGldOverviewListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGldOverviewList200Response>> {
    const requestOptions = await this.apiGldOverviewListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGldOverviewList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve an overview list of GLD objects for the user\'s organization.
   */
  async apiGldOverviewList(
    requestParameters: ApiGldOverviewListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGldOverviewList200Response> {
    const response = await this.apiGldOverviewListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnEventsList without sending the request
   */
  async apiGmnEventsListRequestOpts(
    requestParameters: ApiGmnEventsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["gmn"] != null) {
      queryParameters["gmn"] = requestParameters["gmn"];
    }

    if (requestParameters["eventType"] != null) {
      queryParameters["event_type"] = requestParameters["eventType"];
    }

    if (requestParameters["eventDate"] != null) {
      queryParameters["event_date"] = requestParameters["eventDate"];
    }

    if (requestParameters["measuringpointCode"] != null) {
      queryParameters["measuringpoint_code"] = requestParameters["measuringpointCode"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["measuringpointStartDateGt"] != null) {
      queryParameters["measuringpoint_start_date__gt"] =
        requestParameters["measuringpointStartDateGt"];
    }

    if (requestParameters["measuringpointStartDateGte"] != null) {
      queryParameters["measuringpoint_start_date__gte"] =
        requestParameters["measuringpointStartDateGte"];
    }

    if (requestParameters["measuringpointStartDateLt"] != null) {
      queryParameters["measuringpoint_start_date__lt"] =
        requestParameters["measuringpointStartDateLt"];
    }

    if (requestParameters["measuringpointStartDateLte"] != null) {
      queryParameters["measuringpoint_start_date__lte"] =
        requestParameters["measuringpointStartDateLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/events/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and IntermediateEventFilter. Results are ordered by creation date (descending).
   * Retrieve a list of IntermediateEvent objects.
   */
  async apiGmnEventsListRaw(
    requestParameters: ApiGmnEventsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmnEventsList200Response>> {
    const requestOptions = await this.apiGmnEventsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmnEventsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and IntermediateEventFilter. Results are ordered by creation date (descending).
   * Retrieve a list of IntermediateEvent objects.
   */
  async apiGmnEventsList(
    requestParameters: ApiGmnEventsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmnEventsList200Response> {
    const response = await this.apiGmnEventsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnEventsRead without sending the request
   */
  async apiGmnEventsReadRequestOpts(
    requestParameters: ApiGmnEventsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGmnEventsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/events/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve a single IntermediateEvent object by UUID.
   */
  async apiGmnEventsReadRaw(
    requestParameters: ApiGmnEventsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<IntermediateEvent>> {
    const requestOptions = await this.apiGmnEventsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IntermediateEventFromJSON(jsonValue)
    );
  }

  /**
   * Retrieve a single IntermediateEvent object by UUID.
   */
  async apiGmnEventsRead(
    requestParameters: ApiGmnEventsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<IntermediateEvent> {
    const response = await this.apiGmnEventsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnGmnsList without sending the request
   */
  async apiGmnGmnsListRequestOpts(
    requestParameters: ApiGmnGmnsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["monitoringPurpose"] != null) {
      queryParameters["monitoring_purpose"] = requestParameters["monitoringPurpose"];
    }

    if (requestParameters["groundwaterAspect"] != null) {
      queryParameters["groundwater_aspect"] = requestParameters["groundwaterAspect"];
    }

    if (requestParameters["startDateMonitoring"] != null) {
      queryParameters["start_date_monitoring"] = requestParameters["startDateMonitoring"];
    }

    if (requestParameters["endDateMonitoring"] != null) {
      queryParameters["end_date_monitoring"] = requestParameters["endDateMonitoring"];
    }

    if (requestParameters["objectRegistrationTime"] != null) {
      queryParameters["object_registration_time"] = requestParameters["objectRegistrationTime"];
    }

    if (requestParameters["registrationStatus"] != null) {
      queryParameters["registration_status"] = requestParameters["registrationStatus"];
    }

    if (requestParameters["color"] != null) {
      queryParameters["color"] = requestParameters["color"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["startDateMonitoringGt"] != null) {
      queryParameters["start_date_monitoring__gt"] = requestParameters["startDateMonitoringGt"];
    }

    if (requestParameters["startDateMonitoringGte"] != null) {
      queryParameters["start_date_monitoring__gte"] = requestParameters["startDateMonitoringGte"];
    }

    if (requestParameters["startDateMonitoringLt"] != null) {
      queryParameters["start_date_monitoring__lt"] = requestParameters["startDateMonitoringLt"];
    }

    if (requestParameters["startDateMonitoringLte"] != null) {
      queryParameters["start_date_monitoring__lte"] = requestParameters["startDateMonitoringLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/gmns/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmnFilter. Results are ordered by creation date (descending).
   * Retrieve a list of GMN objects.
   */
  async apiGmnGmnsListRaw(
    requestParameters: ApiGmnGmnsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmnGmnsList200Response>> {
    const requestOptions = await this.apiGmnGmnsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmnGmnsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmnFilter. Results are ordered by creation date (descending).
   * Retrieve a list of GMN objects.
   */
  async apiGmnGmnsList(
    requestParameters: ApiGmnGmnsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmnGmnsList200Response> {
    const response = await this.apiGmnGmnsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnGmnsRead without sending the request
   */
  async apiGmnGmnsReadRequestOpts(
    requestParameters: ApiGmnGmnsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGmnGmnsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/gmns/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve a single GMN object by UUID.
   */
  async apiGmnGmnsReadRaw(
    requestParameters: ApiGmnGmnsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GMN>> {
    const requestOptions = await this.apiGmnGmnsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => GMNFromJSON(jsonValue));
  }

  /**
   * Retrieve a single GMN object by UUID.
   */
  async apiGmnGmnsRead(
    requestParameters: ApiGmnGmnsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GMN> {
    const response = await this.apiGmnGmnsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnIdsList without sending the request
   */
  async apiGmnIdsListRequestOpts(
    requestParameters: ApiGmnIdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["monitoringPurpose"] != null) {
      queryParameters["monitoring_purpose"] = requestParameters["monitoringPurpose"];
    }

    if (requestParameters["groundwaterAspect"] != null) {
      queryParameters["groundwater_aspect"] = requestParameters["groundwaterAspect"];
    }

    if (requestParameters["startDateMonitoring"] != null) {
      queryParameters["start_date_monitoring"] = requestParameters["startDateMonitoring"];
    }

    if (requestParameters["endDateMonitoring"] != null) {
      queryParameters["end_date_monitoring"] = requestParameters["endDateMonitoring"];
    }

    if (requestParameters["objectRegistrationTime"] != null) {
      queryParameters["object_registration_time"] = requestParameters["objectRegistrationTime"];
    }

    if (requestParameters["registrationStatus"] != null) {
      queryParameters["registration_status"] = requestParameters["registrationStatus"];
    }

    if (requestParameters["color"] != null) {
      queryParameters["color"] = requestParameters["color"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["startDateMonitoringGt"] != null) {
      queryParameters["start_date_monitoring__gt"] = requestParameters["startDateMonitoringGt"];
    }

    if (requestParameters["startDateMonitoringGte"] != null) {
      queryParameters["start_date_monitoring__gte"] = requestParameters["startDateMonitoringGte"];
    }

    if (requestParameters["startDateMonitoringLt"] != null) {
      queryParameters["start_date_monitoring__lt"] = requestParameters["startDateMonitoringLt"];
    }

    if (requestParameters["startDateMonitoringLte"] != null) {
      queryParameters["start_date_monitoring__lte"] = requestParameters["startDateMonitoringLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/ids/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmnFilter.
   * Retrieve a list of GMN object IDs.
   */
  async apiGmnIdsListRaw(
    requestParameters: ApiGmnIdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmnIdsList200Response>> {
    const requestOptions = await this.apiGmnIdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmnIdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmnFilter.
   * Retrieve a list of GMN object IDs.
   */
  async apiGmnIdsList(
    requestParameters: ApiGmnIdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmnIdsList200Response> {
    const response = await this.apiGmnIdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnMeasuringpointsList without sending the request
   */
  async apiGmnMeasuringpointsListRequestOpts(
    requestParameters: ApiGmnMeasuringpointsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["gmn"] != null) {
      queryParameters["gmn"] = requestParameters["gmn"];
    }

    if (requestParameters["monitoringTube"] != null) {
      queryParameters["monitoring_tube"] = requestParameters["monitoringTube"];
    }

    if (requestParameters["eventType"] != null) {
      queryParameters["event_type"] = requestParameters["eventType"];
    }

    if (requestParameters["measuringpointCode"] != null) {
      queryParameters["measuringpoint_code"] = requestParameters["measuringpointCode"];
    }

    if (requestParameters["measuringpointStartDate"] != null) {
      queryParameters["measuringpoint_start_date"] = requestParameters["measuringpointStartDate"];
    }

    if (requestParameters["measuringpointEndDate"] != null) {
      queryParameters["measuringpoint_end_date"] = requestParameters["measuringpointEndDate"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["tubeStartDate"] != null) {
      queryParameters["tube_start_date"] = requestParameters["tubeStartDate"];
    }

    if (requestParameters["tubeEndDate"] != null) {
      queryParameters["tube_end_date"] = requestParameters["tubeEndDate"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["measuringpointStartDateGt"] != null) {
      queryParameters["measuringpoint_start_date__gt"] =
        requestParameters["measuringpointStartDateGt"];
    }

    if (requestParameters["measuringpointStartDateGte"] != null) {
      queryParameters["measuringpoint_start_date__gte"] =
        requestParameters["measuringpointStartDateGte"];
    }

    if (requestParameters["measuringpointStartDateLt"] != null) {
      queryParameters["measuringpoint_start_date__lt"] =
        requestParameters["measuringpointStartDateLt"];
    }

    if (requestParameters["measuringpointStartDateLte"] != null) {
      queryParameters["measuringpoint_start_date__lte"] =
        requestParameters["measuringpointStartDateLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/measuringpoints/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and MeasuringPointFilter. Results are ordered by creation date (descending).
   * Retrieve a list of Measuringpoint objects.
   */
  async apiGmnMeasuringpointsListRaw(
    requestParameters: ApiGmnMeasuringpointsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmnMeasuringpointsList200Response>> {
    const requestOptions = await this.apiGmnMeasuringpointsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmnMeasuringpointsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and MeasuringPointFilter. Results are ordered by creation date (descending).
   * Retrieve a list of Measuringpoint objects.
   */
  async apiGmnMeasuringpointsList(
    requestParameters: ApiGmnMeasuringpointsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmnMeasuringpointsList200Response> {
    const response = await this.apiGmnMeasuringpointsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnMeasuringpointsRead without sending the request
   */
  async apiGmnMeasuringpointsReadRequestOpts(
    requestParameters: ApiGmnMeasuringpointsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGmnMeasuringpointsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/measuringpoints/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve a single Measuringpoint object by UUID.
   */
  async apiGmnMeasuringpointsReadRaw(
    requestParameters: ApiGmnMeasuringpointsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Measuringpoint>> {
    const requestOptions = await this.apiGmnMeasuringpointsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => MeasuringpointFromJSON(jsonValue));
  }

  /**
   * Retrieve a single Measuringpoint object by UUID.
   */
  async apiGmnMeasuringpointsRead(
    requestParameters: ApiGmnMeasuringpointsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Measuringpoint> {
    const response = await this.apiGmnMeasuringpointsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmnOverviewList without sending the request
   */
  async apiGmnOverviewListRequestOpts(
    requestParameters: ApiGmnOverviewListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["monitoringPurpose"] != null) {
      queryParameters["monitoring_purpose"] = requestParameters["monitoringPurpose"];
    }

    if (requestParameters["groundwaterAspect"] != null) {
      queryParameters["groundwater_aspect"] = requestParameters["groundwaterAspect"];
    }

    if (requestParameters["startDateMonitoring"] != null) {
      queryParameters["start_date_monitoring"] = requestParameters["startDateMonitoring"];
    }

    if (requestParameters["endDateMonitoring"] != null) {
      queryParameters["end_date_monitoring"] = requestParameters["endDateMonitoring"];
    }

    if (requestParameters["objectRegistrationTime"] != null) {
      queryParameters["object_registration_time"] = requestParameters["objectRegistrationTime"];
    }

    if (requestParameters["registrationStatus"] != null) {
      queryParameters["registration_status"] = requestParameters["registrationStatus"];
    }

    if (requestParameters["color"] != null) {
      queryParameters["color"] = requestParameters["color"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["startDateMonitoringGt"] != null) {
      queryParameters["start_date_monitoring__gt"] = requestParameters["startDateMonitoringGt"];
    }

    if (requestParameters["startDateMonitoringGte"] != null) {
      queryParameters["start_date_monitoring__gte"] = requestParameters["startDateMonitoringGte"];
    }

    if (requestParameters["startDateMonitoringLt"] != null) {
      queryParameters["start_date_monitoring__lt"] = requestParameters["startDateMonitoringLt"];
    }

    if (requestParameters["startDateMonitoringLte"] != null) {
      queryParameters["start_date_monitoring__lte"] = requestParameters["startDateMonitoringLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmn/overview/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmnFilter.
   * Retrieve a list of GMN objects with overview serializer.
   */
  async apiGmnOverviewListRaw(
    requestParameters: ApiGmnOverviewListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmnOverviewList200Response>> {
    const requestOptions = await this.apiGmnOverviewListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmnOverviewList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmnFilter.
   * Retrieve a list of GMN objects with overview serializer.
   */
  async apiGmnOverviewList(
    requestParameters: ApiGmnOverviewListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmnOverviewList200Response> {
    const response = await this.apiGmnOverviewListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwEventsList without sending the request
   */
  async apiGmwEventsListRequestOpts(
    requestParameters: ApiGmwEventsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["gmw"] != null) {
      queryParameters["gmw"] = requestParameters["gmw"];
    }

    if (requestParameters["eventName"] != null) {
      queryParameters["event_name"] = requestParameters["eventName"];
    }

    if (requestParameters["eventDate"] != null) {
      queryParameters["event_date"] = requestParameters["eventDate"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["eventDateGt"] != null) {
      queryParameters["event_date__gt"] = requestParameters["eventDateGt"];
    }

    if (requestParameters["eventDateGte"] != null) {
      queryParameters["event_date__gte"] = requestParameters["eventDateGte"];
    }

    if (requestParameters["eventDateLt"] != null) {
      queryParameters["event_date__lt"] = requestParameters["eventDateLt"];
    }

    if (requestParameters["eventDateLte"] != null) {
      queryParameters["event_date__lte"] = requestParameters["eventDateLte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/events/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and EventFilter. Results are ordered by creation date (descending).
   * API view to retrieve a list of Event objects.
   */
  async apiGmwEventsListRaw(
    requestParameters: ApiGmwEventsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmwEventsList200Response>> {
    const requestOptions = await this.apiGmwEventsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmwEventsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and EventFilter. Results are ordered by creation date (descending).
   * API view to retrieve a list of Event objects.
   */
  async apiGmwEventsList(
    requestParameters: ApiGmwEventsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmwEventsList200Response> {
    const response = await this.apiGmwEventsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwEventsRead without sending the request
   */
  async apiGmwEventsReadRequestOpts(
    requestParameters: ApiGmwEventsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGmwEventsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/events/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a single Event object by UUID.
   */
  async apiGmwEventsReadRaw(
    requestParameters: ApiGmwEventsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Event>> {
    const requestOptions = await this.apiGmwEventsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => EventFromJSON(jsonValue));
  }

  /**
   * API view to retrieve a single Event object by UUID.
   */
  async apiGmwEventsRead(
    requestParameters: ApiGmwEventsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Event> {
    const response = await this.apiGmwEventsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwGeojsonList without sending the request
   */
  async apiGmwGeojsonListRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/geojson/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Get all GMW data as a GeoJSON FeatureCollection
   */
  async apiGmwGeojsonListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmwGeojsonList200Response>> {
    const requestOptions = await this.apiGmwGeojsonListRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmwGeojsonList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Get all GMW data as a GeoJSON FeatureCollection
   */
  async apiGmwGeojsonList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmwGeojsonList200Response> {
    const response = await this.apiGmwGeojsonListRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwGmwsList without sending the request
   */
  async apiGmwGmwsListRequestOpts(
    requestParameters: ApiGmwGmwsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["wellConstructionDate"] != null) {
      queryParameters["well_construction_date"] = requestParameters["wellConstructionDate"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["constructionStandard"] != null) {
      queryParameters["construction_standard"] = requestParameters["constructionStandard"];
    }

    if (requestParameters["initialFunction"] != null) {
      queryParameters["initial_function"] = requestParameters["initialFunction"];
    }

    if (requestParameters["removed"] != null) {
      queryParameters["removed"] = requestParameters["removed"];
    }

    if (requestParameters["groundLevelStable"] != null) {
      queryParameters["ground_level_stable"] = requestParameters["groundLevelStable"];
    }

    if (requestParameters["wellStability"] != null) {
      queryParameters["well_stability"] = requestParameters["wellStability"];
    }

    if (requestParameters["nitgCode"] != null) {
      queryParameters["nitg_code"] = requestParameters["nitgCode"];
    }

    if (requestParameters["wellCode"] != null) {
      queryParameters["well_code"] = requestParameters["wellCode"];
    }

    if (requestParameters["owner"] != null) {
      queryParameters["owner"] = requestParameters["owner"];
    }

    if (requestParameters["wellHeadProtector"] != null) {
      queryParameters["well_head_protector"] = requestParameters["wellHeadProtector"];
    }

    if (requestParameters["deliveredLocation"] != null) {
      queryParameters["delivered_location"] = requestParameters["deliveredLocation"];
    }

    if (requestParameters["horizontalPositioningMethod"] != null) {
      queryParameters["horizontal_positioning_method"] =
        requestParameters["horizontalPositioningMethod"];
    }

    if (requestParameters["localVerticalReferencePoint"] != null) {
      queryParameters["local_vertical_reference_point"] =
        requestParameters["localVerticalReferencePoint"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["verticalDatum"] != null) {
      queryParameters["vertical_datum"] = requestParameters["verticalDatum"];
    }

    if (requestParameters["groundLevelPosition"] != null) {
      queryParameters["ground_level_position"] = requestParameters["groundLevelPosition"];
    }

    if (requestParameters["groundLevelPositioningMethod"] != null) {
      queryParameters["ground_level_positioning_method"] =
        requestParameters["groundLevelPositioningMethod"];
    }

    if (requestParameters["standardizedLocation"] != null) {
      queryParameters["standardized_location"] = requestParameters["standardizedLocation"];
    }

    if (requestParameters["objectRegistrationTime"] != null) {
      queryParameters["object_registration_time"] = requestParameters["objectRegistrationTime"];
    }

    if (requestParameters["registrationStatus"] != null) {
      queryParameters["registration_status"] = requestParameters["registrationStatus"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["internalIdIcontains"] != null) {
      queryParameters["internal_id__icontains"] = requestParameters["internalIdIcontains"];
    }

    if (requestParameters["wellCodeIcontains"] != null) {
      queryParameters["well_code__icontains"] = requestParameters["wellCodeIcontains"];
    }

    if (requestParameters["nitgCodeIcontains"] != null) {
      queryParameters["nitg_code__icontains"] = requestParameters["nitgCodeIcontains"];
    }

    if (requestParameters["wellConstructionDateIcontains"] != null) {
      queryParameters["well_construction_date__icontains"] =
        requestParameters["wellConstructionDateIcontains"];
    }

    if (requestParameters["linkedGmn"] != null) {
      queryParameters["linked_gmn"] = requestParameters["linkedGmn"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/gmws/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmwFilter. Results are ordered by creation date (descending).
   * API view to retrieve a list of GMW objects.
   */
  async apiGmwGmwsListRaw(
    requestParameters: ApiGmwGmwsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmwGmwsList200Response>> {
    const requestOptions = await this.apiGmwGmwsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmwGmwsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmwFilter. Results are ordered by creation date (descending).
   * API view to retrieve a list of GMW objects.
   */
  async apiGmwGmwsList(
    requestParameters: ApiGmwGmwsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmwGmwsList200Response> {
    const response = await this.apiGmwGmwsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwGmwsRead without sending the request
   */
  async apiGmwGmwsReadRequestOpts(
    requestParameters: ApiGmwGmwsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGmwGmwsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/gmws/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a single GMW object by UUID.
   */
  async apiGmwGmwsReadRaw(
    requestParameters: ApiGmwGmwsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GMW>> {
    const requestOptions = await this.apiGmwGmwsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => GMWFromJSON(jsonValue));
  }

  /**
   * API view to retrieve a single GMW object by UUID.
   */
  async apiGmwGmwsRead(
    requestParameters: ApiGmwGmwsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GMW> {
    const response = await this.apiGmwGmwsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwIdsList without sending the request
   */
  async apiGmwIdsListRequestOpts(
    requestParameters: ApiGmwIdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["wellConstructionDate"] != null) {
      queryParameters["well_construction_date"] = requestParameters["wellConstructionDate"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["constructionStandard"] != null) {
      queryParameters["construction_standard"] = requestParameters["constructionStandard"];
    }

    if (requestParameters["initialFunction"] != null) {
      queryParameters["initial_function"] = requestParameters["initialFunction"];
    }

    if (requestParameters["removed"] != null) {
      queryParameters["removed"] = requestParameters["removed"];
    }

    if (requestParameters["groundLevelStable"] != null) {
      queryParameters["ground_level_stable"] = requestParameters["groundLevelStable"];
    }

    if (requestParameters["wellStability"] != null) {
      queryParameters["well_stability"] = requestParameters["wellStability"];
    }

    if (requestParameters["nitgCode"] != null) {
      queryParameters["nitg_code"] = requestParameters["nitgCode"];
    }

    if (requestParameters["wellCode"] != null) {
      queryParameters["well_code"] = requestParameters["wellCode"];
    }

    if (requestParameters["owner"] != null) {
      queryParameters["owner"] = requestParameters["owner"];
    }

    if (requestParameters["wellHeadProtector"] != null) {
      queryParameters["well_head_protector"] = requestParameters["wellHeadProtector"];
    }

    if (requestParameters["deliveredLocation"] != null) {
      queryParameters["delivered_location"] = requestParameters["deliveredLocation"];
    }

    if (requestParameters["horizontalPositioningMethod"] != null) {
      queryParameters["horizontal_positioning_method"] =
        requestParameters["horizontalPositioningMethod"];
    }

    if (requestParameters["localVerticalReferencePoint"] != null) {
      queryParameters["local_vertical_reference_point"] =
        requestParameters["localVerticalReferencePoint"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["verticalDatum"] != null) {
      queryParameters["vertical_datum"] = requestParameters["verticalDatum"];
    }

    if (requestParameters["groundLevelPosition"] != null) {
      queryParameters["ground_level_position"] = requestParameters["groundLevelPosition"];
    }

    if (requestParameters["groundLevelPositioningMethod"] != null) {
      queryParameters["ground_level_positioning_method"] =
        requestParameters["groundLevelPositioningMethod"];
    }

    if (requestParameters["standardizedLocation"] != null) {
      queryParameters["standardized_location"] = requestParameters["standardizedLocation"];
    }

    if (requestParameters["objectRegistrationTime"] != null) {
      queryParameters["object_registration_time"] = requestParameters["objectRegistrationTime"];
    }

    if (requestParameters["registrationStatus"] != null) {
      queryParameters["registration_status"] = requestParameters["registrationStatus"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["internalIdIcontains"] != null) {
      queryParameters["internal_id__icontains"] = requestParameters["internalIdIcontains"];
    }

    if (requestParameters["wellCodeIcontains"] != null) {
      queryParameters["well_code__icontains"] = requestParameters["wellCodeIcontains"];
    }

    if (requestParameters["nitgCodeIcontains"] != null) {
      queryParameters["nitg_code__icontains"] = requestParameters["nitgCodeIcontains"];
    }

    if (requestParameters["wellConstructionDateIcontains"] != null) {
      queryParameters["well_construction_date__icontains"] =
        requestParameters["wellConstructionDateIcontains"];
    }

    if (requestParameters["linkedGmn"] != null) {
      queryParameters["linked_gmn"] = requestParameters["linkedGmn"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/ids/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmwFilter.
   * API view to retrieve a list of GMW object IDs.
   */
  async apiGmwIdsListRaw(
    requestParameters: ApiGmwIdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmwIdsList200Response>> {
    const requestOptions = await this.apiGmwIdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmwIdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmwFilter.
   * API view to retrieve a list of GMW object IDs.
   */
  async apiGmwIdsList(
    requestParameters: ApiGmwIdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmwIdsList200Response> {
    const response = await this.apiGmwIdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwMonitoringtubesList without sending the request
   */
  async apiGmwMonitoringtubesListRequestOpts(
    requestParameters: ApiGmwMonitoringtubesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["gmw"] != null) {
      queryParameters["gmw"] = requestParameters["gmw"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["tubeNumber"] != null) {
      queryParameters["tube_number"] = requestParameters["tubeNumber"];
    }

    if (requestParameters["tubeType"] != null) {
      queryParameters["tube_type"] = requestParameters["tubeType"];
    }

    if (requestParameters["artesianWellCapPresent"] != null) {
      queryParameters["artesian_well_cap_present"] = requestParameters["artesianWellCapPresent"];
    }

    if (requestParameters["sedimentSumpPresent"] != null) {
      queryParameters["sediment_sump_present"] = requestParameters["sedimentSumpPresent"];
    }

    if (requestParameters["sedimentSumpLength"] != null) {
      queryParameters["sediment_sump_length"] = requestParameters["sedimentSumpLength"];
    }

    if (requestParameters["numberOfGeoOhmCables"] != null) {
      queryParameters["number_of_geo_ohm_cables"] = requestParameters["numberOfGeoOhmCables"];
    }

    if (requestParameters["tubeTopDiameter"] != null) {
      queryParameters["tube_top_diameter"] = requestParameters["tubeTopDiameter"];
    }

    if (requestParameters["variableDiameter"] != null) {
      queryParameters["variable_diameter"] = requestParameters["variableDiameter"];
    }

    if (requestParameters["tubeStatus"] != null) {
      queryParameters["tube_status"] = requestParameters["tubeStatus"];
    }

    if (requestParameters["tubeTopPosition"] != null) {
      queryParameters["tube_top_position"] = requestParameters["tubeTopPosition"];
    }

    if (requestParameters["tubeTopPositioningMethod"] != null) {
      queryParameters["tube_top_positioning_method"] =
        requestParameters["tubeTopPositioningMethod"];
    }

    if (requestParameters["tubePartInserted"] != null) {
      queryParameters["tube_part_inserted"] = requestParameters["tubePartInserted"];
    }

    if (requestParameters["tubeInUse"] != null) {
      queryParameters["tube_in_use"] = requestParameters["tubeInUse"];
    }

    if (requestParameters["tubePackingMaterial"] != null) {
      queryParameters["tube_packing_material"] = requestParameters["tubePackingMaterial"];
    }

    if (requestParameters["tubeMaterial"] != null) {
      queryParameters["tube_material"] = requestParameters["tubeMaterial"];
    }

    if (requestParameters["glue"] != null) {
      queryParameters["glue"] = requestParameters["glue"];
    }

    if (requestParameters["screenLength"] != null) {
      queryParameters["screen_length"] = requestParameters["screenLength"];
    }

    if (requestParameters["screenProtection"] != null) {
      queryParameters["screen_protection"] = requestParameters["screenProtection"];
    }

    if (requestParameters["sockMaterial"] != null) {
      queryParameters["sock_material"] = requestParameters["sockMaterial"];
    }

    if (requestParameters["screenTopPosition"] != null) {
      queryParameters["screen_top_position"] = requestParameters["screenTopPosition"];
    }

    if (requestParameters["screenBottomPosition"] != null) {
      queryParameters["screen_bottom_position"] = requestParameters["screenBottomPosition"];
    }

    if (requestParameters["plainTubePartLength"] != null) {
      queryParameters["plain_tube_part_length"] = requestParameters["plainTubePartLength"];
    }

    if (requestParameters["gmnBroId"] != null) {
      queryParameters["gmn_bro_id"] = requestParameters["gmnBroId"];
    }

    if (requestParameters["gmwBroId"] != null) {
      queryParameters["gmw_bro_id"] = requestParameters["gmwBroId"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/monitoringtubes/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and MonitoringTubeFilter. Results are ordered by creation date (descending).
   * API view to retrieve a list of MonitoringTube objects.
   */
  async apiGmwMonitoringtubesListRaw(
    requestParameters: ApiGmwMonitoringtubesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmwMonitoringtubesList200Response>> {
    const requestOptions = await this.apiGmwMonitoringtubesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmwMonitoringtubesList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and MonitoringTubeFilter. Results are ordered by creation date (descending).
   * API view to retrieve a list of MonitoringTube objects.
   */
  async apiGmwMonitoringtubesList(
    requestParameters: ApiGmwMonitoringtubesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmwMonitoringtubesList200Response> {
    const response = await this.apiGmwMonitoringtubesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwMonitoringtubesRead without sending the request
   */
  async apiGmwMonitoringtubesReadRequestOpts(
    requestParameters: ApiGmwMonitoringtubesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGmwMonitoringtubesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/monitoringtubes/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a single MonitoringTube object by UUID.
   */
  async apiGmwMonitoringtubesReadRaw(
    requestParameters: ApiGmwMonitoringtubesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MonitoringTube>> {
    const requestOptions = await this.apiGmwMonitoringtubesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => MonitoringTubeFromJSON(jsonValue));
  }

  /**
   * API view to retrieve a single MonitoringTube object by UUID.
   */
  async apiGmwMonitoringtubesRead(
    requestParameters: ApiGmwMonitoringtubesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MonitoringTube> {
    const response = await this.apiGmwMonitoringtubesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGmwOverviewList without sending the request
   */
  async apiGmwOverviewListRequestOpts(
    requestParameters: ApiGmwOverviewListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["wellConstructionDate"] != null) {
      queryParameters["well_construction_date"] = requestParameters["wellConstructionDate"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["constructionStandard"] != null) {
      queryParameters["construction_standard"] = requestParameters["constructionStandard"];
    }

    if (requestParameters["initialFunction"] != null) {
      queryParameters["initial_function"] = requestParameters["initialFunction"];
    }

    if (requestParameters["removed"] != null) {
      queryParameters["removed"] = requestParameters["removed"];
    }

    if (requestParameters["groundLevelStable"] != null) {
      queryParameters["ground_level_stable"] = requestParameters["groundLevelStable"];
    }

    if (requestParameters["wellStability"] != null) {
      queryParameters["well_stability"] = requestParameters["wellStability"];
    }

    if (requestParameters["nitgCode"] != null) {
      queryParameters["nitg_code"] = requestParameters["nitgCode"];
    }

    if (requestParameters["wellCode"] != null) {
      queryParameters["well_code"] = requestParameters["wellCode"];
    }

    if (requestParameters["owner"] != null) {
      queryParameters["owner"] = requestParameters["owner"];
    }

    if (requestParameters["wellHeadProtector"] != null) {
      queryParameters["well_head_protector"] = requestParameters["wellHeadProtector"];
    }

    if (requestParameters["deliveredLocation"] != null) {
      queryParameters["delivered_location"] = requestParameters["deliveredLocation"];
    }

    if (requestParameters["horizontalPositioningMethod"] != null) {
      queryParameters["horizontal_positioning_method"] =
        requestParameters["horizontalPositioningMethod"];
    }

    if (requestParameters["localVerticalReferencePoint"] != null) {
      queryParameters["local_vertical_reference_point"] =
        requestParameters["localVerticalReferencePoint"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["verticalDatum"] != null) {
      queryParameters["vertical_datum"] = requestParameters["verticalDatum"];
    }

    if (requestParameters["groundLevelPosition"] != null) {
      queryParameters["ground_level_position"] = requestParameters["groundLevelPosition"];
    }

    if (requestParameters["groundLevelPositioningMethod"] != null) {
      queryParameters["ground_level_positioning_method"] =
        requestParameters["groundLevelPositioningMethod"];
    }

    if (requestParameters["standardizedLocation"] != null) {
      queryParameters["standardized_location"] = requestParameters["standardizedLocation"];
    }

    if (requestParameters["objectRegistrationTime"] != null) {
      queryParameters["object_registration_time"] = requestParameters["objectRegistrationTime"];
    }

    if (requestParameters["registrationStatus"] != null) {
      queryParameters["registration_status"] = requestParameters["registrationStatus"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["internalIdIcontains"] != null) {
      queryParameters["internal_id__icontains"] = requestParameters["internalIdIcontains"];
    }

    if (requestParameters["wellCodeIcontains"] != null) {
      queryParameters["well_code__icontains"] = requestParameters["wellCodeIcontains"];
    }

    if (requestParameters["nitgCodeIcontains"] != null) {
      queryParameters["nitg_code__icontains"] = requestParameters["nitgCodeIcontains"];
    }

    if (requestParameters["wellConstructionDateIcontains"] != null) {
      queryParameters["well_construction_date__icontains"] =
        requestParameters["wellConstructionDateIcontains"];
    }

    if (requestParameters["linkedGmn"] != null) {
      queryParameters["linked_gmn"] = requestParameters["linkedGmn"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gmw/overview/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmwFilter.
   * API view to retrieve a list of GMW objects with overview serializer.
   */
  async apiGmwOverviewListRaw(
    requestParameters: ApiGmwOverviewListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGmwOverviewList200Response>> {
    const requestOptions = await this.apiGmwOverviewListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGmwOverviewList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * Supports filtering via DjangoFilterBackend and GmwFilter.
   * API view to retrieve a list of GMW objects with overview serializer.
   */
  async apiGmwOverviewList(
    requestParameters: ApiGmwOverviewListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGmwOverviewList200Response> {
    const response = await this.apiGmwOverviewListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGpdGpdsList without sending the request
   */
  async apiGpdGpdsListRequestOpts(
    requestParameters: ApiGpdGpdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["startTime"] != null) {
      queryParameters["start_time"] = requestParameters["startTime"];
    }

    if (requestParameters["endTime"] != null) {
      queryParameters["end_time"] = requestParameters["endTime"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gpd/gpds/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GPD objects for the user\'s organization.
   */
  async apiGpdGpdsListRaw(
    requestParameters: ApiGpdGpdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGpdGpdsList200Response>> {
    const requestOptions = await this.apiGpdGpdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGpdGpdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GPD objects for the user\'s organization.
   */
  async apiGpdGpdsList(
    requestParameters: ApiGpdGpdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGpdGpdsList200Response> {
    const response = await this.apiGpdGpdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGpdGpdsRead without sending the request
   */
  async apiGpdGpdsReadRequestOpts(
    requestParameters: ApiGpdGpdsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGpdGpdsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gpd/gpds/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GPD object by UUID.
   */
  async apiGpdGpdsReadRaw(
    requestParameters: ApiGpdGpdsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GPD>> {
    const requestOptions = await this.apiGpdGpdsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => GPDFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single GPD object by UUID.
   */
  async apiGpdGpdsRead(
    requestParameters: ApiGpdGpdsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GPD> {
    const response = await this.apiGpdGpdsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGpdIdsList without sending the request
   */
  async apiGpdIdsListRequestOpts(
    requestParameters: ApiGpdIdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["startTime"] != null) {
      queryParameters["start_time"] = requestParameters["startTime"];
    }

    if (requestParameters["endTime"] != null) {
      queryParameters["end_time"] = requestParameters["endTime"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gpd/ids/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GPD IDs for the user\'s organization.
   */
  async apiGpdIdsListRaw(
    requestParameters: ApiGpdIdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGpdIdsList200Response>> {
    const requestOptions = await this.apiGpdIdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGpdIdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GPD IDs for the user\'s organization.
   */
  async apiGpdIdsList(
    requestParameters: ApiGpdIdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGpdIdsList200Response> {
    const response = await this.apiGpdIdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGpdReportsList without sending the request
   */
  async apiGpdReportsListRequestOpts(
    requestParameters: ApiGpdReportsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["gpd"] != null) {
      queryParameters["gpd"] = requestParameters["gpd"];
    }

    if (requestParameters["reportId"] != null) {
      queryParameters["report_id"] = requestParameters["reportId"];
    }

    if (requestParameters["method"] != null) {
      queryParameters["method"] = requestParameters["method"];
    }

    if (requestParameters["beginDate"] != null) {
      queryParameters["begin_date"] = requestParameters["beginDate"];
    }

    if (requestParameters["endDate"] != null) {
      queryParameters["end_date"] = requestParameters["endDate"];
    }

    if (requestParameters["groundwaterUsageFacilityBroId"] != null) {
      queryParameters["groundwater_usage_facility_bro_id"] =
        requestParameters["groundwaterUsageFacilityBroId"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["reportIdIcontains"] != null) {
      queryParameters["report_id__icontains"] = requestParameters["reportIdIcontains"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gpd/reports/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GPD reports for the user\'s organization.
   */
  async apiGpdReportsListRaw(
    requestParameters: ApiGpdReportsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGpdReportsList200Response>> {
    const requestOptions = await this.apiGpdReportsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGpdReportsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GPD reports for the user\'s organization.
   */
  async apiGpdReportsList(
    requestParameters: ApiGpdReportsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGpdReportsList200Response> {
    const response = await this.apiGpdReportsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGpdReportsRead without sending the request
   */
  async apiGpdReportsReadRequestOpts(
    requestParameters: ApiGpdReportsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGpdReportsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gpd/reports/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GPD report by UUID.
   */
  async apiGpdReportsReadRaw(
    requestParameters: ApiGpdReportsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Report>> {
    const requestOptions = await this.apiGpdReportsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ReportFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single GPD report by UUID.
   */
  async apiGpdReportsRead(
    requestParameters: ApiGpdReportsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Report> {
    const response = await this.apiGpdReportsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGpdVolumeSeriesList without sending the request
   */
  async apiGpdVolumeSeriesListRequestOpts(
    requestParameters: ApiGpdVolumeSeriesListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["report"] != null) {
      queryParameters["report"] = requestParameters["report"];
    }

    if (requestParameters["beginDate"] != null) {
      queryParameters["begin_date"] = requestParameters["beginDate"];
    }

    if (requestParameters["endDate"] != null) {
      queryParameters["end_date"] = requestParameters["endDate"];
    }

    if (requestParameters["waterInOut"] != null) {
      queryParameters["water_in_out"] = requestParameters["waterInOut"];
    }

    if (requestParameters["temperature"] != null) {
      queryParameters["temperature"] = requestParameters["temperature"];
    }

    if (requestParameters["volume"] != null) {
      queryParameters["volume"] = requestParameters["volume"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gpd/volume-series/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of VolumeSeries for the user\'s organization.
   */
  async apiGpdVolumeSeriesListRaw(
    requestParameters: ApiGpdVolumeSeriesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGpdVolumeSeriesList200Response>> {
    const requestOptions = await this.apiGpdVolumeSeriesListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGpdVolumeSeriesList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of VolumeSeries for the user\'s organization.
   */
  async apiGpdVolumeSeriesList(
    requestParameters: ApiGpdVolumeSeriesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGpdVolumeSeriesList200Response> {
    const response = await this.apiGpdVolumeSeriesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGpdVolumeSeriesRead without sending the request
   */
  async apiGpdVolumeSeriesReadRequestOpts(
    requestParameters: ApiGpdVolumeSeriesReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGpdVolumeSeriesRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/gpd/volume-series/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single VolumeSeries by UUID.
   */
  async apiGpdVolumeSeriesReadRaw(
    requestParameters: ApiGpdVolumeSeriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<VolumeSeries>> {
    const requestOptions = await this.apiGpdVolumeSeriesReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => VolumeSeriesFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single VolumeSeries by UUID.
   */
  async apiGpdVolumeSeriesRead(
    requestParameters: ApiGpdVolumeSeriesReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<VolumeSeries> {
    const response = await this.apiGpdVolumeSeriesReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufEnergycharacteristicsList without sending the request
   */
  async apiGufEnergycharacteristicsListRequestOpts(
    requestParameters: ApiGufEnergycharacteristicsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["installation"] != null) {
      queryParameters["installation"] = requestParameters["installation"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["energyCold"] != null) {
      queryParameters["energy_cold"] = requestParameters["energyCold"];
    }

    if (requestParameters["energyWarm"] != null) {
      queryParameters["energy_warm"] = requestParameters["energyWarm"];
    }

    if (requestParameters["maximumInfiltrationTemperatureWarm"] != null) {
      queryParameters["maximum_infiltration_temperature_warm"] =
        requestParameters["maximumInfiltrationTemperatureWarm"];
    }

    if (requestParameters["averageInfiltrationTemperatureCold"] != null) {
      queryParameters["average_infiltration_temperature_cold"] =
        requestParameters["averageInfiltrationTemperatureCold"];
    }

    if (requestParameters["averageInfiltrationTemperatureWarm"] != null) {
      queryParameters["average_infiltration_temperature_warm"] =
        requestParameters["averageInfiltrationTemperatureWarm"];
    }

    if (requestParameters["powerCold"] != null) {
      queryParameters["power_cold"] = requestParameters["powerCold"];
    }

    if (requestParameters["powerWarm"] != null) {
      queryParameters["power_warm"] = requestParameters["powerWarm"];
    }

    if (requestParameters["power"] != null) {
      queryParameters["power"] = requestParameters["power"];
    }

    if (requestParameters["averageWarmWater"] != null) {
      queryParameters["average_warm_water"] = requestParameters["averageWarmWater"];
    }

    if (requestParameters["averageColdWater"] != null) {
      queryParameters["average_cold_water"] = requestParameters["averageColdWater"];
    }

    if (requestParameters["maximumYearQuantityWarm"] != null) {
      queryParameters["maximum_year_quantity_warm"] = requestParameters["maximumYearQuantityWarm"];
    }

    if (requestParameters["maximumYearQuantityCold"] != null) {
      queryParameters["maximum_year_quantity_cold"] = requestParameters["maximumYearQuantityCold"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/energycharacteristics/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of Energy Characteristics objects for the user\'s organization.
   */
  async apiGufEnergycharacteristicsListRaw(
    requestParameters: ApiGufEnergycharacteristicsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufEnergycharacteristicsList200Response>> {
    const requestOptions = await this.apiGufEnergycharacteristicsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufEnergycharacteristicsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of Energy Characteristics objects for the user\'s organization.
   */
  async apiGufEnergycharacteristicsList(
    requestParameters: ApiGufEnergycharacteristicsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufEnergycharacteristicsList200Response> {
    const response = await this.apiGufEnergycharacteristicsListRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for apiGufEnergycharacteristicsRead without sending the request
   */
  async apiGufEnergycharacteristicsReadRequestOpts(
    requestParameters: ApiGufEnergycharacteristicsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGufEnergycharacteristicsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/energycharacteristics/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single Energy Characteristics object by UUID.
   */
  async apiGufEnergycharacteristicsReadRaw(
    requestParameters: ApiGufEnergycharacteristicsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<EnergyCharacteristics>> {
    const requestOptions = await this.apiGufEnergycharacteristicsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EnergyCharacteristicsFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single Energy Characteristics object by UUID.
   */
  async apiGufEnergycharacteristicsRead(
    requestParameters: ApiGufEnergycharacteristicsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<EnergyCharacteristics> {
    const response = await this.apiGufEnergycharacteristicsReadRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Creates request options for apiGufEventsList without sending the request
   */
  async apiGufEventsListRequestOpts(
    requestParameters: ApiGufEventsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["guf"] != null) {
      queryParameters["guf"] = requestParameters["guf"];
    }

    if (requestParameters["eventName"] != null) {
      queryParameters["event_name"] = requestParameters["eventName"];
    }

    if (requestParameters["eventDate"] != null) {
      queryParameters["event_date"] = requestParameters["eventDate"];
    }

    if (requestParameters["metadata"] != null) {
      queryParameters["metadata"] = requestParameters["metadata"];
    }

    if (requestParameters["sourcedocumentData"] != null) {
      queryParameters["sourcedocument_data"] = requestParameters["sourcedocumentData"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/events/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GUF Event objects for the user\'s organization.
   */
  async apiGufEventsListRaw(
    requestParameters: ApiGufEventsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufEventsList200Response>> {
    const requestOptions = await this.apiGufEventsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufEventsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GUF Event objects for the user\'s organization.
   */
  async apiGufEventsList(
    requestParameters: ApiGufEventsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufEventsList200Response> {
    const response = await this.apiGufEventsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufEventsRead without sending the request
   */
  async apiGufEventsReadRequestOpts(
    requestParameters: ApiGufEventsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGufEventsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/events/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GUF Event object by UUID.
   */
  async apiGufEventsReadRaw(
    requestParameters: ApiGufEventsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GUFEvent>> {
    const requestOptions = await this.apiGufEventsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => GUFEventFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single GUF Event object by UUID.
   */
  async apiGufEventsRead(
    requestParameters: ApiGufEventsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GUFEvent> {
    const response = await this.apiGufEventsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufGufsList without sending the request
   */
  async apiGufGufsListRequestOpts(
    requestParameters: ApiGufGufsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["startTime"] != null) {
      queryParameters["start_time"] = requestParameters["startTime"];
    }

    if (requestParameters["endTime"] != null) {
      queryParameters["end_time"] = requestParameters["endTime"];
    }

    if (requestParameters["identificationLicence"] != null) {
      queryParameters["identification_licence"] = requestParameters["identificationLicence"];
    }

    if (requestParameters["legalType"] != null) {
      queryParameters["legal_type"] = requestParameters["legalType"];
    }

    if (requestParameters["primaryUsageType"] != null) {
      queryParameters["primary_usage_type"] = requestParameters["primaryUsageType"];
    }

    if (requestParameters["secondaryUsageTypes"] != null) {
      queryParameters["secondary_usage_types"] = requestParameters["secondaryUsageTypes"];
    }

    if (requestParameters["humanConsumption"] != null) {
      queryParameters["human_consumption"] = requestParameters["humanConsumption"];
    }

    if (requestParameters["licensedQuantities"] != null) {
      queryParameters["licensed_quantities"] = requestParameters["licensedQuantities"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/gufs/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GUF objects for the user\'s organization.
   */
  async apiGufGufsListRaw(
    requestParameters: ApiGufGufsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufGufsList200Response>> {
    const requestOptions = await this.apiGufGufsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufGufsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GUF objects for the user\'s organization.
   */
  async apiGufGufsList(
    requestParameters: ApiGufGufsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufGufsList200Response> {
    const response = await this.apiGufGufsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufGufsRead without sending the request
   */
  async apiGufGufsReadRequestOpts(
    requestParameters: ApiGufGufsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGufGufsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/gufs/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single GUF object by UUID.
   */
  async apiGufGufsReadRaw(
    requestParameters: ApiGufGufsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GUFDetail>> {
    const requestOptions = await this.apiGufGufsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => GUFDetailFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single GUF object by UUID.
   */
  async apiGufGufsRead(
    requestParameters: ApiGufGufsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GUFDetail> {
    const response = await this.apiGufGufsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufIdsList without sending the request
   */
  async apiGufIdsListRequestOpts(
    requestParameters: ApiGufIdsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["internalId"] != null) {
      queryParameters["internal_id"] = requestParameters["internalId"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["deliveryAccountableParty"] != null) {
      queryParameters["delivery_accountable_party"] = requestParameters["deliveryAccountableParty"];
    }

    if (requestParameters["qualityRegime"] != null) {
      queryParameters["quality_regime"] = requestParameters["qualityRegime"];
    }

    if (requestParameters["deliveryContext"] != null) {
      queryParameters["delivery_context"] = requestParameters["deliveryContext"];
    }

    if (requestParameters["startTime"] != null) {
      queryParameters["start_time"] = requestParameters["startTime"];
    }

    if (requestParameters["endTime"] != null) {
      queryParameters["end_time"] = requestParameters["endTime"];
    }

    if (requestParameters["identificationLicence"] != null) {
      queryParameters["identification_licence"] = requestParameters["identificationLicence"];
    }

    if (requestParameters["legalType"] != null) {
      queryParameters["legal_type"] = requestParameters["legalType"];
    }

    if (requestParameters["primaryUsageType"] != null) {
      queryParameters["primary_usage_type"] = requestParameters["primaryUsageType"];
    }

    if (requestParameters["secondaryUsageTypes"] != null) {
      queryParameters["secondary_usage_types"] = requestParameters["secondaryUsageTypes"];
    }

    if (requestParameters["humanConsumption"] != null) {
      queryParameters["human_consumption"] = requestParameters["humanConsumption"];
    }

    if (requestParameters["licensedQuantities"] != null) {
      queryParameters["licensed_quantities"] = requestParameters["licensedQuantities"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/ids/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of GUF IDs for the user\'s organization.
   */
  async apiGufIdsListRaw(
    requestParameters: ApiGufIdsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufIdsList200Response>> {
    const requestOptions = await this.apiGufIdsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufIdsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of GUF IDs for the user\'s organization.
   */
  async apiGufIdsList(
    requestParameters: ApiGufIdsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufIdsList200Response> {
    const response = await this.apiGufIdsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufInstallationsList without sending the request
   */
  async apiGufInstallationsListRequestOpts(
    requestParameters: ApiGufInstallationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["guf"] != null) {
      queryParameters["guf"] = requestParameters["guf"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["designInstallationId"] != null) {
      queryParameters["design_installation_id"] = requestParameters["designInstallationId"];
    }

    if (requestParameters["installationFunction"] != null) {
      queryParameters["installation_function"] = requestParameters["installationFunction"];
    }

    if (requestParameters["designInstallationPos"] != null) {
      queryParameters["design_installation_pos"] = requestParameters["designInstallationPos"];
    }

    if (requestParameters["licensedQuantities"] != null) {
      queryParameters["licensed_quantities"] = requestParameters["licensedQuantities"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/installations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of Design Installation objects for the user\'s organization.
   */
  async apiGufInstallationsListRaw(
    requestParameters: ApiGufInstallationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufInstallationsList200Response>> {
    const requestOptions = await this.apiGufInstallationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufInstallationsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of Design Installation objects for the user\'s organization.
   */
  async apiGufInstallationsList(
    requestParameters: ApiGufInstallationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufInstallationsList200Response> {
    const response = await this.apiGufInstallationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufInstallationsRead without sending the request
   */
  async apiGufInstallationsReadRequestOpts(
    requestParameters: ApiGufInstallationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGufInstallationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/installations/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single Design Installation object by UUID.
   */
  async apiGufInstallationsReadRaw(
    requestParameters: ApiGufInstallationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DesignInstallation>> {
    const requestOptions = await this.apiGufInstallationsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DesignInstallationFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single Design Installation object by UUID.
   */
  async apiGufInstallationsRead(
    requestParameters: ApiGufInstallationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DesignInstallation> {
    const response = await this.apiGufInstallationsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufLoopsList without sending the request
   */
  async apiGufLoopsListRequestOpts(
    requestParameters: ApiGufLoopsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["installation"] != null) {
      queryParameters["installation"] = requestParameters["installation"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["designLoopId"] != null) {
      queryParameters["design_loop_id"] = requestParameters["designLoopId"];
    }

    if (requestParameters["loopType"] != null) {
      queryParameters["loop_type"] = requestParameters["loopType"];
    }

    if (requestParameters["startDate"] != null) {
      queryParameters["start_date"] = requestParameters["startDate"];
    }

    if (requestParameters["endDate"] != null) {
      queryParameters["end_date"] = requestParameters["endDate"];
    }

    if (requestParameters["geometryType"] != null) {
      queryParameters["geometry_type"] = requestParameters["geometryType"];
    }

    if (requestParameters["designLoopPos"] != null) {
      queryParameters["design_loop_pos"] = requestParameters["designLoopPos"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/loops/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of Design Loop objects for the user\'s organization.
   */
  async apiGufLoopsListRaw(
    requestParameters: ApiGufLoopsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufLoopsList200Response>> {
    const requestOptions = await this.apiGufLoopsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufLoopsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of Design Loop objects for the user\'s organization.
   */
  async apiGufLoopsList(
    requestParameters: ApiGufLoopsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufLoopsList200Response> {
    const response = await this.apiGufLoopsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufLoopsRead without sending the request
   */
  async apiGufLoopsReadRequestOpts(
    requestParameters: ApiGufLoopsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGufLoopsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/loops/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single Design Loop object by UUID.
   */
  async apiGufLoopsReadRaw(
    requestParameters: ApiGufLoopsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DesignLoop>> {
    const requestOptions = await this.apiGufLoopsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DesignLoopFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single Design Loop object by UUID.
   */
  async apiGufLoopsRead(
    requestParameters: ApiGufLoopsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DesignLoop> {
    const response = await this.apiGufLoopsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufSurfaceinfiltrationsList without sending the request
   */
  async apiGufSurfaceinfiltrationsListRequestOpts(
    requestParameters: ApiGufSurfaceinfiltrationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["installation"] != null) {
      queryParameters["installation"] = requestParameters["installation"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["designSurfaceInfiltrationId"] != null) {
      queryParameters["design_surface_infiltration_id"] =
        requestParameters["designSurfaceInfiltrationId"];
    }

    if (requestParameters["designSurfaceInfiltrationPos"] != null) {
      queryParameters["design_surface_infiltration_pos"] =
        requestParameters["designSurfaceInfiltrationPos"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/surfaceinfiltrations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of Design Surface Infiltration objects for the user\'s organization.
   */
  async apiGufSurfaceinfiltrationsListRaw(
    requestParameters: ApiGufSurfaceinfiltrationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufSurfaceinfiltrationsList200Response>> {
    const requestOptions = await this.apiGufSurfaceinfiltrationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufSurfaceinfiltrationsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of Design Surface Infiltration objects for the user\'s organization.
   */
  async apiGufSurfaceinfiltrationsList(
    requestParameters: ApiGufSurfaceinfiltrationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufSurfaceinfiltrationsList200Response> {
    const response = await this.apiGufSurfaceinfiltrationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufSurfaceinfiltrationsRead without sending the request
   */
  async apiGufSurfaceinfiltrationsReadRequestOpts(
    requestParameters: ApiGufSurfaceinfiltrationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGufSurfaceinfiltrationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/surfaceinfiltrations/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single Design Surface Infiltration object by UUID.
   */
  async apiGufSurfaceinfiltrationsReadRaw(
    requestParameters: ApiGufSurfaceinfiltrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DesignSurfaceInfiltration>> {
    const requestOptions = await this.apiGufSurfaceinfiltrationsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DesignSurfaceInfiltrationFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve the details of a single Design Surface Infiltration object by UUID.
   */
  async apiGufSurfaceinfiltrationsRead(
    requestParameters: ApiGufSurfaceinfiltrationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DesignSurfaceInfiltration> {
    const response = await this.apiGufSurfaceinfiltrationsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufWellsList without sending the request
   */
  async apiGufWellsListRequestOpts(
    requestParameters: ApiGufWellsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["installation"] != null) {
      queryParameters["installation"] = requestParameters["installation"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["designWellId"] != null) {
      queryParameters["design_well_id"] = requestParameters["designWellId"];
    }

    if (requestParameters["wellFunctions"] != null) {
      queryParameters["well_functions"] = requestParameters["wellFunctions"];
    }

    if (requestParameters["height"] != null) {
      queryParameters["height"] = requestParameters["height"];
    }

    if (requestParameters["wellPos"] != null) {
      queryParameters["well_pos"] = requestParameters["wellPos"];
    }

    if (requestParameters["geometryPubliclyAvailable"] != null) {
      queryParameters["geometry_publicly_available"] =
        requestParameters["geometryPubliclyAvailable"];
    }

    if (requestParameters["maximumWellDepth"] != null) {
      queryParameters["maximum_well_depth"] = requestParameters["maximumWellDepth"];
    }

    if (requestParameters["maximumWellDepthPubliclyAvailable"] != null) {
      queryParameters["maximum_well_depth_publicly_available"] =
        requestParameters["maximumWellDepthPubliclyAvailable"];
    }

    if (requestParameters["maximumWellCapacity"] != null) {
      queryParameters["maximum_well_capacity"] = requestParameters["maximumWellCapacity"];
    }

    if (requestParameters["relativeTemperature"] != null) {
      queryParameters["relative_temperature"] = requestParameters["relativeTemperature"];
    }

    if (requestParameters["designScreen"] != null) {
      queryParameters["design_screen"] = requestParameters["designScreen"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/wells/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve a list of Design Well objects for the user\'s organization.
   */
  async apiGufWellsListRaw(
    requestParameters: ApiGufWellsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiGufWellsList200Response>> {
    const requestOptions = await this.apiGufWellsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiGufWellsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * API view to retrieve a list of Design Well objects for the user\'s organization.
   */
  async apiGufWellsList(
    requestParameters: ApiGufWellsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiGufWellsList200Response> {
    const response = await this.apiGufWellsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiGufWellsRead without sending the request
   */
  async apiGufWellsReadRequestOpts(
    requestParameters: ApiGufWellsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiGufWellsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/guf/wells/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * API view to retrieve the details of a single Design Well object by UUID.
   */
  async apiGufWellsReadRaw(
    requestParameters: ApiGufWellsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DesignWell>> {
    const requestOptions = await this.apiGufWellsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DesignWellFromJSON(jsonValue));
  }

  /**
   * API view to retrieve the details of a single Design Well object by UUID.
   */
  async apiGufWellsRead(
    requestParameters: ApiGufWellsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DesignWell> {
    const response = await this.apiGufWellsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiImporttasksCreate without sending the request
   */
  async apiImporttasksCreateRequestOpts(
    requestParameters: ApiImporttasksCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiImporttasksCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/importtasks/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ImportTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksCreateRaw(
    requestParameters: ApiImporttasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ImportTask>> {
    const requestOptions = await this.apiImporttasksCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ImportTaskFromJSON(jsonValue));
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksCreate(
    requestParameters: ApiImporttasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ImportTask> {
    const response = await this.apiImporttasksCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiImporttasksDelete without sending the request
   */
  async apiImporttasksDeleteRequestOpts(
    requestParameters: ApiImporttasksDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiImporttasksDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/importtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksDeleteRaw(
    requestParameters: ApiImporttasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.apiImporttasksDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksDelete(
    requestParameters: ApiImporttasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.apiImporttasksDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for apiImporttasksList without sending the request
   */
  async apiImporttasksListRequestOpts(
    requestParameters: ApiImporttasksListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broDomain"] != null) {
      queryParameters["bro_domain"] = requestParameters["broDomain"];
    }

    if (requestParameters["kvkNumber"] != null) {
      queryParameters["kvk_number"] = requestParameters["kvkNumber"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["log"] != null) {
      queryParameters["log"] = requestParameters["log"];
    }

    if (requestParameters["progress"] != null) {
      queryParameters["progress"] = requestParameters["progress"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/importtasks/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksListRaw(
    requestParameters: ApiImporttasksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiImporttasksList200Response>> {
    const requestOptions = await this.apiImporttasksListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiImporttasksList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksList(
    requestParameters: ApiImporttasksListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiImporttasksList200Response> {
    const response = await this.apiImporttasksListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiImporttasksPartialUpdate without sending the request
   */
  async apiImporttasksPartialUpdateRequestOpts(
    requestParameters: ApiImporttasksPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiImporttasksPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiImporttasksPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/importtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: ImportTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksPartialUpdateRaw(
    requestParameters: ApiImporttasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ImportTask>> {
    const requestOptions = await this.apiImporttasksPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ImportTaskFromJSON(jsonValue));
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksPartialUpdate(
    requestParameters: ApiImporttasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ImportTask> {
    const response = await this.apiImporttasksPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiImporttasksRead without sending the request
   */
  async apiImporttasksReadRequestOpts(
    requestParameters: ApiImporttasksReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiImporttasksRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/importtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksReadRaw(
    requestParameters: ApiImporttasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ImportTask>> {
    const requestOptions = await this.apiImporttasksReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ImportTaskFromJSON(jsonValue));
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksRead(
    requestParameters: ApiImporttasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ImportTask> {
    const response = await this.apiImporttasksReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiImporttasksUpdate without sending the request
   */
  async apiImporttasksUpdateRequestOpts(
    requestParameters: ApiImporttasksUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiImporttasksUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiImporttasksUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/importtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ImportTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksUpdateRaw(
    requestParameters: ApiImporttasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ImportTask>> {
    const requestOptions = await this.apiImporttasksUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ImportTaskFromJSON(jsonValue));
  }

  /**
   * This endpoint handles the import of data from the BRO. As input, it takes one of the four possible BRO Objects (GMN, GMW, GLD, FRD). It saves the imported data in the corresponding datamodel. The progress can be followed in the generated import task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\'  `kvk_number`:     string (*optional*). When not filled in, the kvk of the organisation linked to the user is used.
   */
  async apiImporttasksUpdate(
    requestParameters: ApiImporttasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ImportTask> {
    const response = await this.apiImporttasksUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiList without sending the request
   */
  async apiListRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * **BROstar version**: *1.77.dev0*
   */
  async apiListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.apiListRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * **BROstar version**: *1.77.dev0*
   */
  async apiList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
    await this.apiListRaw(initOverrides);
  }

  /**
   * Creates request options for apiLocalhostRedirectList without sending the request
   */
  async apiLocalhostRedirectListRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/localhost-redirect`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * View that redirects user to localhost:4200. Is used for local frontend development on the stagin environment.
   */
  async apiLocalhostRedirectListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.apiLocalhostRedirectListRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * View that redirects user to localhost:4200. Is used for local frontend development on the stagin environment.
   */
  async apiLocalhostRedirectList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.apiLocalhostRedirectListRaw(initOverrides);
  }

  /**
   * Creates request options for apiObjectimporttasksCreate without sending the request
   */
  async apiObjectimporttasksCreateRequestOpts(
    requestParameters: ApiObjectimporttasksCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiObjectimporttasksCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/objectimporttasks/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ObjectImportTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * POST to this endpoint to trigger an on-demand import of one object without running a full bulk import.  The resulting ``ObjectImportTask`` can be polled to follow the status.  **POST Parameters**  `bro_id`:     String (*required*) e.g. ``\"GMW000000000001\"``.  The domain is     derived automatically from the first three characters.  `force`:     Boolean (*optional*, default ``false``).  When ``true``, skips the     PDOK freshness check and always re-imports the object.
   * Import a single BRO object by its BRO ID.
   */
  async apiObjectimporttasksCreateRaw(
    requestParameters: ApiObjectimporttasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ObjectImportTask>> {
    const requestOptions = await this.apiObjectimporttasksCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ObjectImportTaskFromJSON(jsonValue)
    );
  }

  /**
   * POST to this endpoint to trigger an on-demand import of one object without running a full bulk import.  The resulting ``ObjectImportTask`` can be polled to follow the status.  **POST Parameters**  `bro_id`:     String (*required*) e.g. ``\"GMW000000000001\"``.  The domain is     derived automatically from the first three characters.  `force`:     Boolean (*optional*, default ``false``).  When ``true``, skips the     PDOK freshness check and always re-imports the object.
   * Import a single BRO object by its BRO ID.
   */
  async apiObjectimporttasksCreate(
    requestParameters: ApiObjectimporttasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ObjectImportTask> {
    const response = await this.apiObjectimporttasksCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiObjectimporttasksList without sending the request
   */
  async apiObjectimporttasksListRequestOpts(
    requestParameters: ApiObjectimporttasksListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["broDomain"] != null) {
      queryParameters["bro_domain"] = requestParameters["broDomain"];
    }

    if (requestParameters["force"] != null) {
      queryParameters["force"] = requestParameters["force"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["log"] != null) {
      queryParameters["log"] = requestParameters["log"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/objectimporttasks/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * POST to this endpoint to trigger an on-demand import of one object without running a full bulk import.  The resulting ``ObjectImportTask`` can be polled to follow the status.  **POST Parameters**  `bro_id`:     String (*required*) e.g. ``\"GMW000000000001\"``.  The domain is     derived automatically from the first three characters.  `force`:     Boolean (*optional*, default ``false``).  When ``true``, skips the     PDOK freshness check and always re-imports the object.
   * Import a single BRO object by its BRO ID.
   */
  async apiObjectimporttasksListRaw(
    requestParameters: ApiObjectimporttasksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiObjectimporttasksList200Response>> {
    const requestOptions = await this.apiObjectimporttasksListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiObjectimporttasksList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * POST to this endpoint to trigger an on-demand import of one object without running a full bulk import.  The resulting ``ObjectImportTask`` can be polled to follow the status.  **POST Parameters**  `bro_id`:     String (*required*) e.g. ``\"GMW000000000001\"``.  The domain is     derived automatically from the first three characters.  `force`:     Boolean (*optional*, default ``false``).  When ``true``, skips the     PDOK freshness check and always re-imports the object.
   * Import a single BRO object by its BRO ID.
   */
  async apiObjectimporttasksList(
    requestParameters: ApiObjectimporttasksListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiObjectimporttasksList200Response> {
    const response = await this.apiObjectimporttasksListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiObjectimporttasksRead without sending the request
   */
  async apiObjectimporttasksReadRequestOpts(
    requestParameters: ApiObjectimporttasksReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiObjectimporttasksRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/objectimporttasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * POST to this endpoint to trigger an on-demand import of one object without running a full bulk import.  The resulting ``ObjectImportTask`` can be polled to follow the status.  **POST Parameters**  `bro_id`:     String (*required*) e.g. ``\"GMW000000000001\"``.  The domain is     derived automatically from the first three characters.  `force`:     Boolean (*optional*, default ``false``).  When ``true``, skips the     PDOK freshness check and always re-imports the object.
   * Import a single BRO object by its BRO ID.
   */
  async apiObjectimporttasksReadRaw(
    requestParameters: ApiObjectimporttasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ObjectImportTask>> {
    const requestOptions = await this.apiObjectimporttasksReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ObjectImportTaskFromJSON(jsonValue)
    );
  }

  /**
   * POST to this endpoint to trigger an on-demand import of one object without running a full bulk import.  The resulting ``ObjectImportTask`` can be polled to follow the status.  **POST Parameters**  `bro_id`:     String (*required*) e.g. ``\"GMW000000000001\"``.  The domain is     derived automatically from the first three characters.  `force`:     Boolean (*optional*, default ``false``).  When ``true``, skips the     PDOK freshness check and always re-imports the object.
   * Import a single BRO object by its BRO ID.
   */
  async apiObjectimporttasksRead(
    requestParameters: ApiObjectimporttasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ObjectImportTask> {
    const response = await this.apiObjectimporttasksReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiOrganisationsList without sending the request
   */
  async apiOrganisationsListRequestOpts(
    requestParameters: ApiOrganisationsListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["kvkNumber"] != null) {
      queryParameters["kvk_number"] = requestParameters["kvkNumber"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/organisations/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async apiOrganisationsListRaw(
    requestParameters: ApiOrganisationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiOrganisationsList200Response>> {
    const requestOptions = await this.apiOrganisationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiOrganisationsList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   */
  async apiOrganisationsList(
    requestParameters: ApiOrganisationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiOrganisationsList200Response> {
    const response = await this.apiOrganisationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiOrganisationsPartialUpdate without sending the request
   */
  async apiOrganisationsPartialUpdateRequestOpts(
    requestParameters: ApiOrganisationsPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiOrganisationsPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiOrganisationsPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/organisations/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: FullOrganisationToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async apiOrganisationsPartialUpdateRaw(
    requestParameters: ApiOrganisationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FullOrganisation>> {
    const requestOptions = await this.apiOrganisationsPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FullOrganisationFromJSON(jsonValue)
    );
  }

  /**
   */
  async apiOrganisationsPartialUpdate(
    requestParameters: ApiOrganisationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FullOrganisation> {
    const response = await this.apiOrganisationsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiOrganisationsRead without sending the request
   */
  async apiOrganisationsReadRequestOpts(
    requestParameters: ApiOrganisationsReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiOrganisationsRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/organisations/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async apiOrganisationsReadRaw(
    requestParameters: ApiOrganisationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Organisation>> {
    const requestOptions = await this.apiOrganisationsReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationFromJSON(jsonValue));
  }

  /**
   */
  async apiOrganisationsRead(
    requestParameters: ApiOrganisationsReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Organisation> {
    const response = await this.apiOrganisationsReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksCheckStatus without sending the request
   */
  async apiUploadtasksCheckStatusRequestOpts(
    requestParameters: ApiUploadtasksCheckStatusRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiUploadtasksCheckStatus().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiUploadtasksCheckStatus().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/{uuid}/check_status/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * **Returns**:     - 200 when the task was UNFINISHED and successfully checked its status      - 202 when the task was stuck on PENDING. Start the task.      - 303 when the task finished with a status of COMPLETED or FAILED      - 303 when the task was still running      - 304 when the task was UNFINISHED, but remains UNFINISHED after a check with the BRO
   * Check the status of the upload task.
   */
  async apiUploadtasksCheckStatusRaw(
    requestParameters: ApiUploadtasksCheckStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadTask>> {
    const requestOptions = await this.apiUploadtasksCheckStatusRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadTaskFromJSON(jsonValue));
  }

  /**
   * **Returns**:     - 200 when the task was UNFINISHED and successfully checked its status      - 202 when the task was stuck on PENDING. Start the task.      - 303 when the task finished with a status of COMPLETED or FAILED      - 303 when the task was still running      - 304 when the task was UNFINISHED, but remains UNFINISHED after a check with the BRO
   * Check the status of the upload task.
   */
  async apiUploadtasksCheckStatus(
    requestParameters: ApiUploadtasksCheckStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadTask> {
    const response = await this.apiUploadtasksCheckStatusRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksCreate without sending the request
   */
  async apiUploadtasksCreateRequestOpts(
    requestParameters: ApiUploadtasksCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiUploadtasksCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksCreateRaw(
    requestParameters: ApiUploadtasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadTask>> {
    const requestOptions = await this.apiUploadtasksCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadTaskFromJSON(jsonValue));
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksCreate(
    requestParameters: ApiUploadtasksCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadTask> {
    const response = await this.apiUploadtasksCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksDelete without sending the request
   */
  async apiUploadtasksDeleteRequestOpts(
    requestParameters: ApiUploadtasksDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiUploadtasksDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksDeleteRaw(
    requestParameters: ApiUploadtasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.apiUploadtasksDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksDelete(
    requestParameters: ApiUploadtasksDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.apiUploadtasksDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for apiUploadtasksList without sending the request
   */
  async apiUploadtasksListRequestOpts(
    requestParameters: ApiUploadtasksListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broDomain"] != null) {
      queryParameters["bro_domain"] = requestParameters["broDomain"];
    }

    if (requestParameters["projectNumber"] != null) {
      queryParameters["project_number"] = requestParameters["projectNumber"];
    }

    if (requestParameters["registrationType"] != null) {
      queryParameters["registration_type"] = requestParameters["registrationType"];
    }

    if (requestParameters["requestType"] != null) {
      queryParameters["request_type"] = requestParameters["requestType"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["log"] != null) {
      queryParameters["log"] = requestParameters["log"];
    }

    if (requestParameters["broErrors"] != null) {
      queryParameters["bro_errors"] = requestParameters["broErrors"];
    }

    if (requestParameters["progress"] != null) {
      queryParameters["progress"] = requestParameters["progress"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["broDeliveryUrl"] != null) {
      queryParameters["bro_delivery_url"] = requestParameters["broDeliveryUrl"];
    }

    if (requestParameters["requestReferenceIcontains"] != null) {
      queryParameters["request_reference__icontains"] =
        requestParameters["requestReferenceIcontains"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["registrationTypeIcontains"] != null) {
      queryParameters["registration_type__icontains"] =
        requestParameters["registrationTypeIcontains"];
    }

    if (requestParameters["createdLt"] != null) {
      queryParameters["created__lt"] = requestParameters["createdLt"];
    }

    if (requestParameters["createdLte"] != null) {
      queryParameters["created__lte"] = requestParameters["createdLte"];
    }

    if (requestParameters["createdGt"] != null) {
      queryParameters["created__gt"] = requestParameters["createdGt"];
    }

    if (requestParameters["createdGte"] != null) {
      queryParameters["created__gte"] = requestParameters["createdGte"];
    }

    if (requestParameters["updatedLt"] != null) {
      queryParameters["updated__lt"] = requestParameters["updatedLt"];
    }

    if (requestParameters["updatedLte"] != null) {
      queryParameters["updated__lte"] = requestParameters["updatedLte"];
    }

    if (requestParameters["updatedGt"] != null) {
      queryParameters["updated__gt"] = requestParameters["updatedGt"];
    }

    if (requestParameters["updatedGte"] != null) {
      queryParameters["updated__gte"] = requestParameters["updatedGte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksListRaw(
    requestParameters: ApiUploadtasksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiUploadtasksList200Response>> {
    const requestOptions = await this.apiUploadtasksListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiUploadtasksList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksList(
    requestParameters: ApiUploadtasksListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiUploadtasksList200Response> {
    const response = await this.apiUploadtasksListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksOverviewList without sending the request
   */
  async apiUploadtasksOverviewListRequestOpts(
    requestParameters: ApiUploadtasksOverviewListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["uuid"] != null) {
      queryParameters["uuid"] = requestParameters["uuid"];
    }

    if (requestParameters["created"] != null) {
      queryParameters["created"] = requestParameters["created"];
    }

    if (requestParameters["updated"] != null) {
      queryParameters["updated"] = requestParameters["updated"];
    }

    if (requestParameters["dataOwner"] != null) {
      queryParameters["data_owner"] = requestParameters["dataOwner"];
    }

    if (requestParameters["broDomain"] != null) {
      queryParameters["bro_domain"] = requestParameters["broDomain"];
    }

    if (requestParameters["projectNumber"] != null) {
      queryParameters["project_number"] = requestParameters["projectNumber"];
    }

    if (requestParameters["registrationType"] != null) {
      queryParameters["registration_type"] = requestParameters["registrationType"];
    }

    if (requestParameters["requestType"] != null) {
      queryParameters["request_type"] = requestParameters["requestType"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["log"] != null) {
      queryParameters["log"] = requestParameters["log"];
    }

    if (requestParameters["broErrors"] != null) {
      queryParameters["bro_errors"] = requestParameters["broErrors"];
    }

    if (requestParameters["progress"] != null) {
      queryParameters["progress"] = requestParameters["progress"];
    }

    if (requestParameters["broId"] != null) {
      queryParameters["bro_id"] = requestParameters["broId"];
    }

    if (requestParameters["broDeliveryUrl"] != null) {
      queryParameters["bro_delivery_url"] = requestParameters["broDeliveryUrl"];
    }

    if (requestParameters["requestReferenceIcontains"] != null) {
      queryParameters["request_reference__icontains"] =
        requestParameters["requestReferenceIcontains"];
    }

    if (requestParameters["broIdIcontains"] != null) {
      queryParameters["bro_id__icontains"] = requestParameters["broIdIcontains"];
    }

    if (requestParameters["registrationTypeIcontains"] != null) {
      queryParameters["registration_type__icontains"] =
        requestParameters["registrationTypeIcontains"];
    }

    if (requestParameters["createdLt"] != null) {
      queryParameters["created__lt"] = requestParameters["createdLt"];
    }

    if (requestParameters["createdLte"] != null) {
      queryParameters["created__lte"] = requestParameters["createdLte"];
    }

    if (requestParameters["createdGt"] != null) {
      queryParameters["created__gt"] = requestParameters["createdGt"];
    }

    if (requestParameters["createdGte"] != null) {
      queryParameters["created__gte"] = requestParameters["createdGte"];
    }

    if (requestParameters["updatedLt"] != null) {
      queryParameters["updated__lt"] = requestParameters["updatedLt"];
    }

    if (requestParameters["updatedLte"] != null) {
      queryParameters["updated__lte"] = requestParameters["updatedLte"];
    }

    if (requestParameters["updatedGt"] != null) {
      queryParameters["updated__gt"] = requestParameters["updatedGt"];
    }

    if (requestParameters["updatedGte"] != null) {
      queryParameters["updated__gte"] = requestParameters["updatedGte"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/overview/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * This endpoint returns an overview of all upload tasks, supporting filtering via query parameters. The response uses a lightweight serializer for performance and summary display.  **Query Parameters**:     - Any field supported by the UploadTaskFilter (see filterset for details).  **Returns**:     - 200 OK: A paginated list of upload task overviews.
   * API endpoint that provides a filtered, paginated list of upload tasks with summary information.
   */
  async apiUploadtasksOverviewListRaw(
    requestParameters: ApiUploadtasksOverviewListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiUploadtasksOverviewList200Response>> {
    const requestOptions = await this.apiUploadtasksOverviewListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiUploadtasksOverviewList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   * This endpoint returns an overview of all upload tasks, supporting filtering via query parameters. The response uses a lightweight serializer for performance and summary display.  **Query Parameters**:     - Any field supported by the UploadTaskFilter (see filterset for details).  **Returns**:     - 200 OK: A paginated list of upload task overviews.
   * API endpoint that provides a filtered, paginated list of upload tasks with summary information.
   */
  async apiUploadtasksOverviewList(
    requestParameters: ApiUploadtasksOverviewListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiUploadtasksOverviewList200Response> {
    const response = await this.apiUploadtasksOverviewListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksPartialUpdate without sending the request
   */
  async apiUploadtasksPartialUpdateRequestOpts(
    requestParameters: ApiUploadtasksPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiUploadtasksPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiUploadtasksPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UploadTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksPartialUpdateRaw(
    requestParameters: ApiUploadtasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadTask>> {
    const requestOptions = await this.apiUploadtasksPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadTaskFromJSON(jsonValue));
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksPartialUpdate(
    requestParameters: ApiUploadtasksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadTask> {
    const response = await this.apiUploadtasksPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksRead without sending the request
   */
  async apiUploadtasksReadRequestOpts(
    requestParameters: ApiUploadtasksReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiUploadtasksRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksReadRaw(
    requestParameters: ApiUploadtasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadTask>> {
    const requestOptions = await this.apiUploadtasksReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadTaskFromJSON(jsonValue));
  }

  /**
   * It takes the registration type, request type, and the sourcedocument data as input. This API handles the transformation, validation, and delivery of the data. The status of this process can be followed in the generated upload task instance.  **POST Parameters**  `bro_domain`:     String (*required*) options: \'GMN\', \'GMW\', \'GLD\', \'FRD\', \'GAR\'  `kvk_number`:     string (*optional*) When not filled in, the kvk of the organization linked to the user is used.  `project_number`:     String (*optional*) When not filled in, the default project number is used. If that doesn\'t exist, the upload fails.  `registration_type`:     String (*required*)  `request_type`:     String (*required*) options: registration, replace, insert, move, delete. Some may not be possible for a given registration_type. Check out [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb) for the possible combinations  `metadata`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)  `sourcedocument_data`:     dict (*required*) see [the documentation for this endpoint](https://github.com/nens/bro-hub/blob/main/upload_examples.ipynb)
   * This endpoint handles the upload of data to the BRO.
   */
  async apiUploadtasksRead(
    requestParameters: ApiUploadtasksReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadTask> {
    const response = await this.apiUploadtasksReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksReadXml without sending the request
   */
  async apiUploadtasksReadXmlRequestOpts(
    requestParameters: ApiUploadtasksReadXmlRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiUploadtasksReadXml().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/{uuid}/read_xml/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Returns the generated XML file for this upload task.
   */
  async apiUploadtasksReadXmlRaw(
    requestParameters: ApiUploadtasksReadXmlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<string>> {
    const requestOptions = await this.apiUploadtasksReadXmlRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Returns the generated XML file for this upload task.
   */
  async apiUploadtasksReadXml(
    requestParameters: ApiUploadtasksReadXmlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<string> {
    const response = await this.apiUploadtasksReadXmlRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUploadtasksUpdate without sending the request
   */
  async apiUploadtasksUpdateRequestOpts(
    requestParameters: ApiUploadtasksUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["uuid"] == null) {
      throw new runtime.RequiredError(
        "uuid",
        'Required parameter "uuid" was null or undefined when calling apiUploadtasksUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiUploadtasksUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/uploadtasks/{uuid}/`;
    urlPath = urlPath.replace("{uuid}", encodeURIComponent(String(requestParameters["uuid"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UploadTaskToJSON(requestParameters["data"]),
    };
  }

  /**
   * Allow updates but always enforce the user\'s organisation as data_owner.
   */
  async apiUploadtasksUpdateRaw(
    requestParameters: ApiUploadtasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UploadTask>> {
    const requestOptions = await this.apiUploadtasksUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadTaskFromJSON(jsonValue));
  }

  /**
   * Allow updates but always enforce the user\'s organisation as data_owner.
   */
  async apiUploadtasksUpdate(
    requestParameters: ApiUploadtasksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UploadTask> {
    const response = await this.apiUploadtasksUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUsersCreate without sending the request
   */
  async apiUsersCreateRequestOpts(
    requestParameters: ApiUsersCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiUsersCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/users/`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UserToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async apiUsersCreateRaw(
    requestParameters: ApiUsersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<User>> {
    const requestOptions = await this.apiUsersCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
  }

  /**
   */
  async apiUsersCreate(
    requestParameters: ApiUsersCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<User> {
    const response = await this.apiUsersCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUsersDelete without sending the request
   */
  async apiUsersDeleteRequestOpts(
    requestParameters: ApiUsersDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling apiUsersDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async apiUsersDeleteRaw(
    requestParameters: ApiUsersDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.apiUsersDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiUsersDelete(
    requestParameters: ApiUsersDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.apiUsersDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for apiUsersList without sending the request
   */
  async apiUsersListRequestOpts(
    requestParameters: ApiUsersListRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/users/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async apiUsersListRaw(
    requestParameters: ApiUsersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiUsersList200Response>> {
    const requestOptions = await this.apiUsersListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiUsersList200ResponseFromJSON(jsonValue)
    );
  }

  /**
   */
  async apiUsersList(
    requestParameters: ApiUsersListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiUsersList200Response> {
    const response = await this.apiUsersListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUsersLoggedIn without sending the request
   */
  async apiUsersLoggedInRequestOpts(
    requestParameters: ApiUsersLoggedInRequest
  ): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/users/logged-in/`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Endpoint to check whether the use is logged in or not.
   */
  async apiUsersLoggedInRaw(
    requestParameters: ApiUsersLoggedInRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UserLoggedIn>> {
    const requestOptions = await this.apiUsersLoggedInRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserLoggedInFromJSON(jsonValue));
  }

  /**
   * Endpoint to check whether the use is logged in or not.
   */
  async apiUsersLoggedIn(
    requestParameters: ApiUsersLoggedInRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UserLoggedIn> {
    const response = await this.apiUsersLoggedInRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUsersPartialUpdate without sending the request
   */
  async apiUsersPartialUpdateRequestOpts(
    requestParameters: ApiUsersPartialUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling apiUsersPartialUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiUsersPartialUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UserToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async apiUsersPartialUpdateRaw(
    requestParameters: ApiUsersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<User>> {
    const requestOptions = await this.apiUsersPartialUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
  }

  /**
   */
  async apiUsersPartialUpdate(
    requestParameters: ApiUsersPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<User> {
    const response = await this.apiUsersPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUsersRead without sending the request
   */
  async apiUsersReadRequestOpts(
    requestParameters: ApiUsersReadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling apiUsersRead().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   */
  async apiUsersReadRaw(
    requestParameters: ApiUsersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<User>> {
    const requestOptions = await this.apiUsersReadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
  }

  /**
   */
  async apiUsersRead(
    requestParameters: ApiUsersReadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<User> {
    const response = await this.apiUsersReadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiUsersUpdate without sending the request
   */
  async apiUsersUpdateRequestOpts(
    requestParameters: ApiUsersUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling apiUsersUpdate().'
      );
    }

    if (requestParameters["data"] == null) {
      throw new runtime.RequiredError(
        "data",
        'Required parameter "data" was null or undefined when calling apiUsersUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/api/users/{id}/`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UserToJSON(requestParameters["data"]),
    };
  }

  /**
   */
  async apiUsersUpdateRaw(
    requestParameters: ApiUsersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<User>> {
    const requestOptions = await this.apiUsersUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
  }

  /**
   */
  async apiUsersUpdate(
    requestParameters: ApiUsersUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<User> {
    const response = await this.apiUsersUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ApiBulkuploadsCreateBulkUploadTypeEnum = {
  Gar: "GAR",
  Gld: "GLD",
  Gmn: "GMN",
} as const;
export type ApiBulkuploadsCreateBulkUploadTypeEnum =
  (typeof ApiBulkuploadsCreateBulkUploadTypeEnum)[keyof typeof ApiBulkuploadsCreateBulkUploadTypeEnum];
/**
 * @export
 */
export const ApiBulkuploadsCreateRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type ApiBulkuploadsCreateRequestTypeEnum =
  (typeof ApiBulkuploadsCreateRequestTypeEnum)[keyof typeof ApiBulkuploadsCreateRequestTypeEnum];
/**
 * @export
 */
export const ApiBulkuploadsCreateStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ApiBulkuploadsCreateStatusEnum =
  (typeof ApiBulkuploadsCreateStatusEnum)[keyof typeof ApiBulkuploadsCreateStatusEnum];
/**
 * @export
 */
export const ApiBulkuploadsPartialUpdateBulkUploadTypeEnum = {
  Gar: "GAR",
  Gld: "GLD",
  Gmn: "GMN",
} as const;
export type ApiBulkuploadsPartialUpdateBulkUploadTypeEnum =
  (typeof ApiBulkuploadsPartialUpdateBulkUploadTypeEnum)[keyof typeof ApiBulkuploadsPartialUpdateBulkUploadTypeEnum];
/**
 * @export
 */
export const ApiBulkuploadsPartialUpdateRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type ApiBulkuploadsPartialUpdateRequestTypeEnum =
  (typeof ApiBulkuploadsPartialUpdateRequestTypeEnum)[keyof typeof ApiBulkuploadsPartialUpdateRequestTypeEnum];
/**
 * @export
 */
export const ApiBulkuploadsPartialUpdateStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ApiBulkuploadsPartialUpdateStatusEnum =
  (typeof ApiBulkuploadsPartialUpdateStatusEnum)[keyof typeof ApiBulkuploadsPartialUpdateStatusEnum];
/**
 * @export
 */
export const ApiBulkuploadsUpdateBulkUploadTypeEnum = {
  Gar: "GAR",
  Gld: "GLD",
  Gmn: "GMN",
} as const;
export type ApiBulkuploadsUpdateBulkUploadTypeEnum =
  (typeof ApiBulkuploadsUpdateBulkUploadTypeEnum)[keyof typeof ApiBulkuploadsUpdateBulkUploadTypeEnum];
/**
 * @export
 */
export const ApiBulkuploadsUpdateRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type ApiBulkuploadsUpdateRequestTypeEnum =
  (typeof ApiBulkuploadsUpdateRequestTypeEnum)[keyof typeof ApiBulkuploadsUpdateRequestTypeEnum];
/**
 * @export
 */
export const ApiBulkuploadsUpdateStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ApiBulkuploadsUpdateStatusEnum =
  (typeof ApiBulkuploadsUpdateStatusEnum)[keyof typeof ApiBulkuploadsUpdateStatusEnum];
/**
 * @export
 */
export const ApiGarAnalysesListStatusQualityControlEnum = {
  Afgekeurd: "afgekeurd",
  Goedgekeurd: "goedgekeurd",
  Onbeslist: "onbeslist",
  Onbekend: "onbekend",
} as const;
export type ApiGarAnalysesListStatusQualityControlEnum =
  (typeof ApiGarAnalysesListStatusQualityControlEnum)[keyof typeof ApiGarAnalysesListStatusQualityControlEnum];
/**
 * @export
 */
export const ApiGarFieldmeasurementsListQualityControlStatusEnum = {
  Afgekeurd: "afgekeurd",
  Goedgekeurd: "goedgekeurd",
  Onbeslist: "onbeslist",
  Onbekend: "onbekend",
} as const;
export type ApiGarFieldmeasurementsListQualityControlStatusEnum =
  (typeof ApiGarFieldmeasurementsListQualityControlStatusEnum)[keyof typeof ApiGarFieldmeasurementsListQualityControlStatusEnum];
/**
 * @export
 */
export const ApiGmnEventsListEventTypeEnum = {
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnTubeReference: "GMN_TubeReference",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnStartRegistration: "GMN_StartRegistration",
} as const;
export type ApiGmnEventsListEventTypeEnum =
  (typeof ApiGmnEventsListEventTypeEnum)[keyof typeof ApiGmnEventsListEventTypeEnum];
/**
 * @export
 */
export const ApiGmnMeasuringpointsListEventTypeEnum = {
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnTubeReference: "GMN_TubeReference",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnStartRegistration: "GMN_StartRegistration",
} as const;
export type ApiGmnMeasuringpointsListEventTypeEnum =
  (typeof ApiGmnMeasuringpointsListEventTypeEnum)[keyof typeof ApiGmnMeasuringpointsListEventTypeEnum];
/**
 * @export
 */
export const ApiGpdReportsListMethodEnum = {
  Berekening: "berekening",
  Watermeter: "watermeter",
  Onbekend: "onbekend",
} as const;
export type ApiGpdReportsListMethodEnum =
  (typeof ApiGpdReportsListMethodEnum)[keyof typeof ApiGpdReportsListMethodEnum];
/**
 * @export
 */
export const ApiGpdVolumeSeriesListWaterInOutEnum = {
  Ingebracht: "ingebracht",
  Onttrokken: "onttrokken",
} as const;
export type ApiGpdVolumeSeriesListWaterInOutEnum =
  (typeof ApiGpdVolumeSeriesListWaterInOutEnum)[keyof typeof ApiGpdVolumeSeriesListWaterInOutEnum];
/**
 * @export
 */
export const ApiGpdVolumeSeriesListTemperatureEnum = {
  Warm: "warm",
  Koud: "koud",
  Onbekend: "onbekend",
} as const;
export type ApiGpdVolumeSeriesListTemperatureEnum =
  (typeof ApiGpdVolumeSeriesListTemperatureEnum)[keyof typeof ApiGpdVolumeSeriesListTemperatureEnum];
/**
 * @export
 */
export const ApiGufGufsListQualityRegimeEnum = {
  Imbro: "IMBRO",
  ImbroA: "IMBRO/A",
} as const;
export type ApiGufGufsListQualityRegimeEnum =
  (typeof ApiGufGufsListQualityRegimeEnum)[keyof typeof ApiGufGufsListQualityRegimeEnum];
/**
 * @export
 */
export const ApiGufGufsListDeliveryContextEnum = {
  Waterwet: "waterwet",
  Omgevingswet: "omgevingswet",
} as const;
export type ApiGufGufsListDeliveryContextEnum =
  (typeof ApiGufGufsListDeliveryContextEnum)[keyof typeof ApiGufGufsListDeliveryContextEnum];
/**
 * @export
 */
export const ApiGufGufsListLegalTypeEnum = {
  Melding: "melding",
  Beschikking: "beschikking",
} as const;
export type ApiGufGufsListLegalTypeEnum =
  (typeof ApiGufGufsListLegalTypeEnum)[keyof typeof ApiGufGufsListLegalTypeEnum];
/**
 * @export
 */
export const ApiGufGufsListPrimaryUsageTypeEnum = {
  AgrarischeDoeleinden: "agrarischeDoeleinden",
  Bemaling: "bemaling",
  Brandblusvoorziening: "brandblusvoorziening",
  GeslotenBodemenergiesysteem: "geslotenBodemenergiesysteem",
  Grondwatersanering: "grondwatersanering",
  IndustrieleToepassing: "industrieleToepassing",
  OpenBodemenergiesysteem: "openBodemenergiesysteem",
  OpenbareDrinkwatervoorziening: "openbareDrinkwatervoorziening",
  OverigeDoeleinden: "overigeDoeleinden",
} as const;
export type ApiGufGufsListPrimaryUsageTypeEnum =
  (typeof ApiGufGufsListPrimaryUsageTypeEnum)[keyof typeof ApiGufGufsListPrimaryUsageTypeEnum];
/**
 * @export
 */
export const ApiGufGufsListHumanConsumptionEnum = {
  Ja: "ja",
  Nee: "nee",
  Onbekend: "onbekend",
} as const;
export type ApiGufGufsListHumanConsumptionEnum =
  (typeof ApiGufGufsListHumanConsumptionEnum)[keyof typeof ApiGufGufsListHumanConsumptionEnum];
/**
 * @export
 */
export const ApiGufIdsListQualityRegimeEnum = {
  Imbro: "IMBRO",
  ImbroA: "IMBRO/A",
} as const;
export type ApiGufIdsListQualityRegimeEnum =
  (typeof ApiGufIdsListQualityRegimeEnum)[keyof typeof ApiGufIdsListQualityRegimeEnum];
/**
 * @export
 */
export const ApiGufIdsListDeliveryContextEnum = {
  Waterwet: "waterwet",
  Omgevingswet: "omgevingswet",
} as const;
export type ApiGufIdsListDeliveryContextEnum =
  (typeof ApiGufIdsListDeliveryContextEnum)[keyof typeof ApiGufIdsListDeliveryContextEnum];
/**
 * @export
 */
export const ApiGufIdsListLegalTypeEnum = {
  Melding: "melding",
  Beschikking: "beschikking",
} as const;
export type ApiGufIdsListLegalTypeEnum =
  (typeof ApiGufIdsListLegalTypeEnum)[keyof typeof ApiGufIdsListLegalTypeEnum];
/**
 * @export
 */
export const ApiGufIdsListPrimaryUsageTypeEnum = {
  AgrarischeDoeleinden: "agrarischeDoeleinden",
  Bemaling: "bemaling",
  Brandblusvoorziening: "brandblusvoorziening",
  GeslotenBodemenergiesysteem: "geslotenBodemenergiesysteem",
  Grondwatersanering: "grondwatersanering",
  IndustrieleToepassing: "industrieleToepassing",
  OpenBodemenergiesysteem: "openBodemenergiesysteem",
  OpenbareDrinkwatervoorziening: "openbareDrinkwatervoorziening",
  OverigeDoeleinden: "overigeDoeleinden",
} as const;
export type ApiGufIdsListPrimaryUsageTypeEnum =
  (typeof ApiGufIdsListPrimaryUsageTypeEnum)[keyof typeof ApiGufIdsListPrimaryUsageTypeEnum];
/**
 * @export
 */
export const ApiGufIdsListHumanConsumptionEnum = {
  Ja: "ja",
  Nee: "nee",
  Onbekend: "onbekend",
} as const;
export type ApiGufIdsListHumanConsumptionEnum =
  (typeof ApiGufIdsListHumanConsumptionEnum)[keyof typeof ApiGufIdsListHumanConsumptionEnum];
/**
 * @export
 */
export const ApiGufInstallationsListInstallationFunctionEnum = {
  GeslotenBodemenergiesysteem: "geslotenBodemenergiesysteem",
  OnttrekkingEnRetournering: "onttrekkingEnRetournering",
  Onttrekking: "onttrekking",
  Infiltratie: "infiltratie",
  InfiltratieEnOnttrekking: "infiltratieEnOnttrekking",
  OpenBodemenergiesysteem: "openBodemenergiesysteem",
} as const;
export type ApiGufInstallationsListInstallationFunctionEnum =
  (typeof ApiGufInstallationsListInstallationFunctionEnum)[keyof typeof ApiGufInstallationsListInstallationFunctionEnum];
/**
 * @export
 */
export const ApiGufLoopsListLoopTypeEnum = {
  Horizontaal: "horizontaal",
  Korf: "korf",
  Verticaal: "verticaal",
} as const;
export type ApiGufLoopsListLoopTypeEnum =
  (typeof ApiGufLoopsListLoopTypeEnum)[keyof typeof ApiGufLoopsListLoopTypeEnum];
/**
 * @export
 */
export const ApiGufWellsListGeometryPubliclyAvailableEnum = {
  Ja: "ja",
  Nee: "nee",
} as const;
export type ApiGufWellsListGeometryPubliclyAvailableEnum =
  (typeof ApiGufWellsListGeometryPubliclyAvailableEnum)[keyof typeof ApiGufWellsListGeometryPubliclyAvailableEnum];
/**
 * @export
 */
export const ApiGufWellsListMaximumWellDepthPubliclyAvailableEnum = {
  Ja: "ja",
  Nee: "nee",
} as const;
export type ApiGufWellsListMaximumWellDepthPubliclyAvailableEnum =
  (typeof ApiGufWellsListMaximumWellDepthPubliclyAvailableEnum)[keyof typeof ApiGufWellsListMaximumWellDepthPubliclyAvailableEnum];
/**
 * @export
 */
export const ApiGufWellsListRelativeTemperatureEnum = {
  Koud: "koud",
  Warm: "warm",
  Onbekend: "onbekend",
} as const;
export type ApiGufWellsListRelativeTemperatureEnum =
  (typeof ApiGufWellsListRelativeTemperatureEnum)[keyof typeof ApiGufWellsListRelativeTemperatureEnum];
/**
 * @export
 */
export const ApiImporttasksListBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type ApiImporttasksListBroDomainEnum =
  (typeof ApiImporttasksListBroDomainEnum)[keyof typeof ApiImporttasksListBroDomainEnum];
/**
 * @export
 */
export const ApiImporttasksListStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ApiImporttasksListStatusEnum =
  (typeof ApiImporttasksListStatusEnum)[keyof typeof ApiImporttasksListStatusEnum];
/**
 * @export
 */
export const ApiObjectimporttasksListBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type ApiObjectimporttasksListBroDomainEnum =
  (typeof ApiObjectimporttasksListBroDomainEnum)[keyof typeof ApiObjectimporttasksListBroDomainEnum];
/**
 * @export
 */
export const ApiObjectimporttasksListStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ApiObjectimporttasksListStatusEnum =
  (typeof ApiObjectimporttasksListStatusEnum)[keyof typeof ApiObjectimporttasksListStatusEnum];
/**
 * @export
 */
export const ApiUploadtasksListBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type ApiUploadtasksListBroDomainEnum =
  (typeof ApiUploadtasksListBroDomainEnum)[keyof typeof ApiUploadtasksListBroDomainEnum];
/**
 * @export
 */
export const ApiUploadtasksListRegistrationTypeEnum = {
  GmnStartRegistration: "GMN_StartRegistration",
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnTubeReference: "GMN_TubeReference",
  GmnClosure: "GMN_Closure",
  GmwConstruction: "GMW_Construction",
  GmwElectrodeStatus: "GMW_ElectrodeStatus",
  GmwGroundLevel: "GMW_GroundLevel",
  GmwGroundLevelMeasuring: "GMW_GroundLevelMeasuring",
  GmwInsertion: "GMW_Insertion",
  GmwLengthening: "GMW_Lengthening",
  GmwShortening: "GMW_Shortening",
  GmwPositions: "GMW_Positions",
  GmwPositionsMeasuring: "GMW_PositionsMeasuring",
  GmwShift: "GMW_Shift",
  GmwMaintainer: "GMW_Maintainer",
  GmwOwner: "GMW_Owner",
  GmwRemoval: "GMW_Removal",
  GmwSubsequentAdditionalSurvey: "GMW_SubsequentAdditionalSurvey",
  GmwTubeStatus: "GMW_TubeStatus",
  GmwWellHeadProtector: "GMW_WellHeadProtector",
  Gar: "GAR",
  GldStartRegistration: "GLD_StartRegistration",
  GldAddition: "GLD_Addition",
  GldClosure: "GLD_Closure",
  FrdStartRegistration: "FRD_StartRegistration",
  FrdGemMeasurementConfiguration: "FRD_GEM_MeasurementConfiguration",
  FrdGemMeasurement: "FRD_GEM_Measurement",
  FrdEmmInstrumentConfiguration: "FRD_EMM_InstrumentConfiguration",
  FrdEmmMeasurement: "FRD_EMM_Measurement",
  FrdClosure: "FRD_Closure",
  Cpt: "CPT",
  BhrP: "BHR-P",
  BhrG: "BHR-G",
  BhrGt: "BHR-GT",
  Sfr: "SFR",
  GufStartRegistration: "GUF_StartRegistration",
  GufNewLicense: "GUF_NewLicense",
  GufExpandedRealisedInstallation: "GUF_ExpandedRealisedInstallation",
  GufWellFunction: "GUF_WellFunction",
  GufHeight: "GUF_Height",
  GufClosure: "GUF_Closure",
  GufAddRealisedInstallation: "GUF_AddRealisedInstallation",
  GufClosureRealisedPart: "GUF_ClosureRealisedPart",
  GpdStartRegistration: "GPD_StartRegistration",
  GpdAddReport: "GPD_AddReport",
  GpdEndRegistration: "GPD_EndRegistration",
} as const;
export type ApiUploadtasksListRegistrationTypeEnum =
  (typeof ApiUploadtasksListRegistrationTypeEnum)[keyof typeof ApiUploadtasksListRegistrationTypeEnum];
/**
 * @export
 */
export const ApiUploadtasksListRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type ApiUploadtasksListRequestTypeEnum =
  (typeof ApiUploadtasksListRequestTypeEnum)[keyof typeof ApiUploadtasksListRequestTypeEnum];
/**
 * @export
 */
export const ApiUploadtasksListStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ApiUploadtasksListStatusEnum =
  (typeof ApiUploadtasksListStatusEnum)[keyof typeof ApiUploadtasksListStatusEnum];
/**
 * @export
 */
export const ApiUploadtasksOverviewListBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type ApiUploadtasksOverviewListBroDomainEnum =
  (typeof ApiUploadtasksOverviewListBroDomainEnum)[keyof typeof ApiUploadtasksOverviewListBroDomainEnum];
/**
 * @export
 */
export const ApiUploadtasksOverviewListRegistrationTypeEnum = {
  GmnStartRegistration: "GMN_StartRegistration",
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnTubeReference: "GMN_TubeReference",
  GmnClosure: "GMN_Closure",
  GmwConstruction: "GMW_Construction",
  GmwElectrodeStatus: "GMW_ElectrodeStatus",
  GmwGroundLevel: "GMW_GroundLevel",
  GmwGroundLevelMeasuring: "GMW_GroundLevelMeasuring",
  GmwInsertion: "GMW_Insertion",
  GmwLengthening: "GMW_Lengthening",
  GmwShortening: "GMW_Shortening",
  GmwPositions: "GMW_Positions",
  GmwPositionsMeasuring: "GMW_PositionsMeasuring",
  GmwShift: "GMW_Shift",
  GmwMaintainer: "GMW_Maintainer",
  GmwOwner: "GMW_Owner",
  GmwRemoval: "GMW_Removal",
  GmwSubsequentAdditionalSurvey: "GMW_SubsequentAdditionalSurvey",
  GmwTubeStatus: "GMW_TubeStatus",
  GmwWellHeadProtector: "GMW_WellHeadProtector",
  Gar: "GAR",
  GldStartRegistration: "GLD_StartRegistration",
  GldAddition: "GLD_Addition",
  GldClosure: "GLD_Closure",
  FrdStartRegistration: "FRD_StartRegistration",
  FrdGemMeasurementConfiguration: "FRD_GEM_MeasurementConfiguration",
  FrdGemMeasurement: "FRD_GEM_Measurement",
  FrdEmmInstrumentConfiguration: "FRD_EMM_InstrumentConfiguration",
  FrdEmmMeasurement: "FRD_EMM_Measurement",
  FrdClosure: "FRD_Closure",
  Cpt: "CPT",
  BhrP: "BHR-P",
  BhrG: "BHR-G",
  BhrGt: "BHR-GT",
  Sfr: "SFR",
  GufStartRegistration: "GUF_StartRegistration",
  GufNewLicense: "GUF_NewLicense",
  GufExpandedRealisedInstallation: "GUF_ExpandedRealisedInstallation",
  GufWellFunction: "GUF_WellFunction",
  GufHeight: "GUF_Height",
  GufClosure: "GUF_Closure",
  GufAddRealisedInstallation: "GUF_AddRealisedInstallation",
  GufClosureRealisedPart: "GUF_ClosureRealisedPart",
  GpdStartRegistration: "GPD_StartRegistration",
  GpdAddReport: "GPD_AddReport",
  GpdEndRegistration: "GPD_EndRegistration",
} as const;
export type ApiUploadtasksOverviewListRegistrationTypeEnum =
  (typeof ApiUploadtasksOverviewListRegistrationTypeEnum)[keyof typeof ApiUploadtasksOverviewListRegistrationTypeEnum];
/**
 * @export
 */
export const ApiUploadtasksOverviewListRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type ApiUploadtasksOverviewListRequestTypeEnum =
  (typeof ApiUploadtasksOverviewListRequestTypeEnum)[keyof typeof ApiUploadtasksOverviewListRequestTypeEnum];
/**
 * @export
 */
export const ApiUploadtasksOverviewListStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ApiUploadtasksOverviewListStatusEnum =
  (typeof ApiUploadtasksOverviewListStatusEnum)[keyof typeof ApiUploadtasksOverviewListStatusEnum];
